// This file was auto-generated by Fern from our API Definition.
import { normalizeClientOptionsWithAuth } from "../../../../BaseClient.js";
import { mergeHeaders } from "../../../../core/headers.js";
import * as core from "../../../../core/index.js";
import * as environments from "../../../../environments.js";
import { handleNonStatusCodeError } from "../../../../errors/handleNonStatusCodeError.js";
import * as errors from "../../../../errors/index.js";
import * as AgentaApi from "../../../index.js";
/**
 * Chat platform channels — connections, agents, spaces, grants, and the inbound event log.
 */
export class ChannelsClient {
    _options;
    constructor(options) {
        this._options = normalizeClientOptionsWithAuth(options);
    }
    /**
     * @param {ChannelsClient.RequestOptions} requestOptions - Request-specific configuration.
     *
     * @example
     *     await client.channels.ingestSlackEvent()
     */
    ingestSlackEvent(requestOptions) {
        return core.HttpResponsePromise.fromPromise(this.__ingestSlackEvent(requestOptions));
    }
    async __ingestSlackEvent(requestOptions) {
        const _authRequest = await this._options.authProvider.getAuthRequest();
        const _headers = mergeHeaders(_authRequest.headers, this._options?.headers, requestOptions?.headers);
        const _response = await core.fetcher({
            url: core.url.join((await core.Supplier.get(this._options.baseUrl)) ??
                (await core.Supplier.get(this._options.environment)) ??
                environments.AgentaApiEnvironment.Default, "channels/slack/events/"),
            method: "POST",
            headers: _headers,
            queryParameters: requestOptions?.queryParams,
            timeoutMs: (requestOptions?.timeoutInSeconds ?? this._options?.timeoutInSeconds ?? 30) * 1000,
            maxRetries: requestOptions?.maxRetries ?? this._options?.maxRetries,
            withCredentials: true,
            abortSignal: requestOptions?.abortSignal,
            fetchFn: this._options?.fetch,
            logging: this._options.logging,
        });
        if (_response.ok) {
            return { data: _response.body, rawResponse: _response.rawResponse };
        }
        if (_response.error.reason === "status-code") {
            throw new errors.AgentaApiError({
                statusCode: _response.error.statusCode,
                body: _response.error.body,
                rawResponse: _response.rawResponse,
            });
        }
        return handleNonStatusCodeError(_response.error, _response.rawResponse, "POST", "/channels/slack/events/");
    }
    /**
     * @param {AgentaApi.IngestTelegramEventRequest} request
     * @param {ChannelsClient.RequestOptions} requestOptions - Request-specific configuration.
     *
     * @throws {@link AgentaApi.UnprocessableEntityError}
     *
     * @example
     *     await client.channels.ingestTelegramEvent({
     *         routing_token: "routing_token"
     *     })
     */
    ingestTelegramEvent(request, requestOptions) {
        return core.HttpResponsePromise.fromPromise(this.__ingestTelegramEvent(request, requestOptions));
    }
    async __ingestTelegramEvent(request, requestOptions) {
        const { routing_token: routingToken } = request;
        const _authRequest = await this._options.authProvider.getAuthRequest();
        const _headers = mergeHeaders(_authRequest.headers, this._options?.headers, requestOptions?.headers);
        const _response = await core.fetcher({
            url: core.url.join((await core.Supplier.get(this._options.baseUrl)) ??
                (await core.Supplier.get(this._options.environment)) ??
                environments.AgentaApiEnvironment.Default, `channels/telegram/events/${core.url.encodePathParam(routingToken)}/`),
            method: "POST",
            headers: _headers,
            queryParameters: requestOptions?.queryParams,
            timeoutMs: (requestOptions?.timeoutInSeconds ?? this._options?.timeoutInSeconds ?? 30) * 1000,
            maxRetries: requestOptions?.maxRetries ?? this._options?.maxRetries,
            withCredentials: true,
            abortSignal: requestOptions?.abortSignal,
            fetchFn: this._options?.fetch,
            logging: this._options.logging,
        });
        if (_response.ok) {
            return { data: _response.body, rawResponse: _response.rawResponse };
        }
        if (_response.error.reason === "status-code") {
            switch (_response.error.statusCode) {
                case 422:
                    throw new AgentaApi.UnprocessableEntityError(_response.error.body, _response.rawResponse);
                default:
                    throw new errors.AgentaApiError({
                        statusCode: _response.error.statusCode,
                        body: _response.error.body,
                        rawResponse: _response.rawResponse,
                    });
            }
        }
        return handleNonStatusCodeError(_response.error, _response.rawResponse, "POST", "/channels/telegram/events/{routing_token}/");
    }
    /**
     * Meta's subscription check: echo `hub.challenge` as plain text when
     * `hub.verify_token` is the token a WhatsApp connection handed its
     * operator. The token starts with the phone number ID, which picks the
     * one connection to compare against. Echoing grants nothing, but an
     * unknown token is refused so the URL answers only for its own numbers.
     *
     * @param {ChannelsClient.RequestOptions} requestOptions - Request-specific configuration.
     *
     * @example
     *     await client.channels.verifyWhatsappWebhook()
     */
    verifyWhatsappWebhook(requestOptions) {
        return core.HttpResponsePromise.fromPromise(this.__verifyWhatsappWebhook(requestOptions));
    }
    async __verifyWhatsappWebhook(requestOptions) {
        const _authRequest = await this._options.authProvider.getAuthRequest();
        const _headers = mergeHeaders(_authRequest.headers, this._options?.headers, requestOptions?.headers);
        const _response = await core.fetcher({
            url: core.url.join((await core.Supplier.get(this._options.baseUrl)) ??
                (await core.Supplier.get(this._options.environment)) ??
                environments.AgentaApiEnvironment.Default, "channels/whatsapp/events/"),
            method: "GET",
            headers: _headers,
            queryParameters: requestOptions?.queryParams,
            responseType: "text",
            timeoutMs: (requestOptions?.timeoutInSeconds ?? this._options?.timeoutInSeconds ?? 30) * 1000,
            maxRetries: requestOptions?.maxRetries ?? this._options?.maxRetries,
            withCredentials: true,
            abortSignal: requestOptions?.abortSignal,
            fetchFn: this._options?.fetch,
            logging: this._options.logging,
        });
        if (_response.ok) {
            return { data: _response.body, rawResponse: _response.rawResponse };
        }
        if (_response.error.reason === "status-code") {
            throw new errors.AgentaApiError({
                statusCode: _response.error.statusCode,
                body: _response.error.body,
                rawResponse: _response.rawResponse,
            });
        }
        return handleNonStatusCodeError(_response.error, _response.rawResponse, "GET", "/channels/whatsapp/events/");
    }
    /**
     * @param {ChannelsClient.RequestOptions} requestOptions - Request-specific configuration.
     *
     * @example
     *     await client.channels.ingestWhatsappEvent()
     */
    ingestWhatsappEvent(requestOptions) {
        return core.HttpResponsePromise.fromPromise(this.__ingestWhatsappEvent(requestOptions));
    }
    async __ingestWhatsappEvent(requestOptions) {
        const _authRequest = await this._options.authProvider.getAuthRequest();
        const _headers = mergeHeaders(_authRequest.headers, this._options?.headers, requestOptions?.headers);
        const _response = await core.fetcher({
            url: core.url.join((await core.Supplier.get(this._options.baseUrl)) ??
                (await core.Supplier.get(this._options.environment)) ??
                environments.AgentaApiEnvironment.Default, "channels/whatsapp/events/"),
            method: "POST",
            headers: _headers,
            queryParameters: requestOptions?.queryParams,
            timeoutMs: (requestOptions?.timeoutInSeconds ?? this._options?.timeoutInSeconds ?? 30) * 1000,
            maxRetries: requestOptions?.maxRetries ?? this._options?.maxRetries,
            withCredentials: true,
            abortSignal: requestOptions?.abortSignal,
            fetchFn: this._options?.fetch,
            logging: this._options.logging,
        });
        if (_response.ok) {
            return { data: _response.body, rawResponse: _response.rawResponse };
        }
        if (_response.error.reason === "status-code") {
            throw new errors.AgentaApiError({
                statusCode: _response.error.statusCode,
                body: _response.error.body,
                rawResponse: _response.rawResponse,
            });
        }
        return handleNonStatusCodeError(_response.error, _response.rawResponse, "POST", "/channels/whatsapp/events/");
    }
    /**
     * @param {ChannelsClient.RequestOptions} requestOptions - Request-specific configuration.
     *
     * @example
     *     await client.channels.ingestBridgeEvent()
     */
    ingestBridgeEvent(requestOptions) {
        return core.HttpResponsePromise.fromPromise(this.__ingestBridgeEvent(requestOptions));
    }
    async __ingestBridgeEvent(requestOptions) {
        const _authRequest = await this._options.authProvider.getAuthRequest();
        const _headers = mergeHeaders(_authRequest.headers, this._options?.headers, requestOptions?.headers);
        const _response = await core.fetcher({
            url: core.url.join((await core.Supplier.get(this._options.baseUrl)) ??
                (await core.Supplier.get(this._options.environment)) ??
                environments.AgentaApiEnvironment.Default, "channels/bridge/events/"),
            method: "POST",
            headers: _headers,
            queryParameters: requestOptions?.queryParams,
            timeoutMs: (requestOptions?.timeoutInSeconds ?? this._options?.timeoutInSeconds ?? 30) * 1000,
            maxRetries: requestOptions?.maxRetries ?? this._options?.maxRetries,
            withCredentials: true,
            abortSignal: requestOptions?.abortSignal,
            fetchFn: this._options?.fetch,
            logging: this._options.logging,
        });
        if (_response.ok) {
            return { data: _response.body, rawResponse: _response.rawResponse };
        }
        if (_response.error.reason === "status-code") {
            throw new errors.AgentaApiError({
                statusCode: _response.error.statusCode,
                body: _response.error.body,
                rawResponse: _response.rawResponse,
            });
        }
        return handleNonStatusCodeError(_response.error, _response.rawResponse, "POST", "/channels/bridge/events/");
    }
    /**
     * @param {ChannelsClient.RequestOptions} requestOptions - Request-specific configuration.
     *
     * @example
     *     await client.channels.ingestAgentaEvent()
     */
    ingestAgentaEvent(requestOptions) {
        return core.HttpResponsePromise.fromPromise(this.__ingestAgentaEvent(requestOptions));
    }
    async __ingestAgentaEvent(requestOptions) {
        const _authRequest = await this._options.authProvider.getAuthRequest();
        const _headers = mergeHeaders(_authRequest.headers, this._options?.headers, requestOptions?.headers);
        const _response = await core.fetcher({
            url: core.url.join((await core.Supplier.get(this._options.baseUrl)) ??
                (await core.Supplier.get(this._options.environment)) ??
                environments.AgentaApiEnvironment.Default, "channels/agenta/events/"),
            method: "POST",
            headers: _headers,
            queryParameters: requestOptions?.queryParams,
            timeoutMs: (requestOptions?.timeoutInSeconds ?? this._options?.timeoutInSeconds ?? 30) * 1000,
            maxRetries: requestOptions?.maxRetries ?? this._options?.maxRetries,
            withCredentials: true,
            abortSignal: requestOptions?.abortSignal,
            fetchFn: this._options?.fetch,
            logging: this._options.logging,
        });
        if (_response.ok) {
            return { data: _response.body, rawResponse: _response.rawResponse };
        }
        if (_response.error.reason === "status-code") {
            throw new errors.AgentaApiError({
                statusCode: _response.error.statusCode,
                body: _response.error.body,
                rawResponse: _response.rawResponse,
            });
        }
        return handleNonStatusCodeError(_response.error, _response.rawResponse, "POST", "/channels/agenta/events/");
    }
    /**
     * @param {AgentaApi.IngestEmbedEventRequest} request
     * @param {ChannelsClient.RequestOptions} requestOptions - Request-specific configuration.
     *
     * @throws {@link AgentaApi.UnprocessableEntityError}
     *
     * @example
     *     await client.channels.ingestEmbedEvent({
     *         embed_id: "embed_id"
     *     })
     */
    ingestEmbedEvent(request, requestOptions) {
        return core.HttpResponsePromise.fromPromise(this.__ingestEmbedEvent(request, requestOptions));
    }
    async __ingestEmbedEvent(request, requestOptions) {
        const { embed_id: embedId } = request;
        const _authRequest = await this._options.authProvider.getAuthRequest();
        const _headers = mergeHeaders(_authRequest.headers, this._options?.headers, requestOptions?.headers);
        const _response = await core.fetcher({
            url: core.url.join((await core.Supplier.get(this._options.baseUrl)) ??
                (await core.Supplier.get(this._options.environment)) ??
                environments.AgentaApiEnvironment.Default, `channels/embed/events/${core.url.encodePathParam(embedId)}/`),
            method: "POST",
            headers: _headers,
            queryParameters: requestOptions?.queryParams,
            timeoutMs: (requestOptions?.timeoutInSeconds ?? this._options?.timeoutInSeconds ?? 30) * 1000,
            maxRetries: requestOptions?.maxRetries ?? this._options?.maxRetries,
            withCredentials: true,
            abortSignal: requestOptions?.abortSignal,
            fetchFn: this._options?.fetch,
            logging: this._options.logging,
        });
        if (_response.ok) {
            return { data: _response.body, rawResponse: _response.rawResponse };
        }
        if (_response.error.reason === "status-code") {
            switch (_response.error.statusCode) {
                case 422:
                    throw new AgentaApi.UnprocessableEntityError(_response.error.body, _response.rawResponse);
                default:
                    throw new errors.AgentaApiError({
                        statusCode: _response.error.statusCode,
                        body: _response.error.body,
                        rawResponse: _response.rawResponse,
                    });
            }
        }
        return handleNonStatusCodeError(_response.error, _response.rawResponse, "POST", "/channels/embed/events/{embed_id}/");
    }
    /**
     * @param {AgentaApi.FetchEmbedConfigRequest} request
     * @param {ChannelsClient.RequestOptions} requestOptions - Request-specific configuration.
     *
     * @throws {@link AgentaApi.UnprocessableEntityError}
     *
     * @example
     *     await client.channels.fetchEmbedConfig({
     *         embed_id: "embed_id"
     *     })
     */
    fetchEmbedConfig(request, requestOptions) {
        return core.HttpResponsePromise.fromPromise(this.__fetchEmbedConfig(request, requestOptions));
    }
    async __fetchEmbedConfig(request, requestOptions) {
        const { embed_id: embedId } = request;
        const _authRequest = await this._options.authProvider.getAuthRequest();
        const _headers = mergeHeaders(_authRequest.headers, this._options?.headers, requestOptions?.headers);
        const _response = await core.fetcher({
            url: core.url.join((await core.Supplier.get(this._options.baseUrl)) ??
                (await core.Supplier.get(this._options.environment)) ??
                environments.AgentaApiEnvironment.Default, `channels/embed/${core.url.encodePathParam(embedId)}/config`),
            method: "GET",
            headers: _headers,
            queryParameters: requestOptions?.queryParams,
            timeoutMs: (requestOptions?.timeoutInSeconds ?? this._options?.timeoutInSeconds ?? 30) * 1000,
            maxRetries: requestOptions?.maxRetries ?? this._options?.maxRetries,
            withCredentials: true,
            abortSignal: requestOptions?.abortSignal,
            fetchFn: this._options?.fetch,
            logging: this._options.logging,
        });
        if (_response.ok) {
            return { data: _response.body, rawResponse: _response.rawResponse };
        }
        if (_response.error.reason === "status-code") {
            switch (_response.error.statusCode) {
                case 422:
                    throw new AgentaApi.UnprocessableEntityError(_response.error.body, _response.rawResponse);
                default:
                    throw new errors.AgentaApiError({
                        statusCode: _response.error.statusCode,
                        body: _response.error.body,
                        rawResponse: _response.rawResponse,
                    });
            }
        }
        return handleNonStatusCodeError(_response.error, _response.rawResponse, "GET", "/channels/embed/{embed_id}/config");
    }
    /**
     * @param {AgentaApi.ListEmbedConversationsRequest} request
     * @param {ChannelsClient.RequestOptions} requestOptions - Request-specific configuration.
     *
     * @throws {@link AgentaApi.UnprocessableEntityError}
     *
     * @example
     *     await client.channels.listEmbedConversations({
     *         embed_id: "embed_id"
     *     })
     */
    listEmbedConversations(request, requestOptions) {
        return core.HttpResponsePromise.fromPromise(this.__listEmbedConversations(request, requestOptions));
    }
    async __listEmbedConversations(request, requestOptions) {
        const { embed_id: embedId } = request;
        const _authRequest = await this._options.authProvider.getAuthRequest();
        const _headers = mergeHeaders(_authRequest.headers, this._options?.headers, requestOptions?.headers);
        const _response = await core.fetcher({
            url: core.url.join((await core.Supplier.get(this._options.baseUrl)) ??
                (await core.Supplier.get(this._options.environment)) ??
                environments.AgentaApiEnvironment.Default, `channels/embed/${core.url.encodePathParam(embedId)}/conversations`),
            method: "GET",
            headers: _headers,
            queryParameters: requestOptions?.queryParams,
            timeoutMs: (requestOptions?.timeoutInSeconds ?? this._options?.timeoutInSeconds ?? 30) * 1000,
            maxRetries: requestOptions?.maxRetries ?? this._options?.maxRetries,
            withCredentials: true,
            abortSignal: requestOptions?.abortSignal,
            fetchFn: this._options?.fetch,
            logging: this._options.logging,
        });
        if (_response.ok) {
            return { data: _response.body, rawResponse: _response.rawResponse };
        }
        if (_response.error.reason === "status-code") {
            switch (_response.error.statusCode) {
                case 422:
                    throw new AgentaApi.UnprocessableEntityError(_response.error.body, _response.rawResponse);
                default:
                    throw new errors.AgentaApiError({
                        statusCode: _response.error.statusCode,
                        body: _response.error.body,
                        rawResponse: _response.rawResponse,
                    });
            }
        }
        return handleNonStatusCodeError(_response.error, _response.rawResponse, "GET", "/channels/embed/{embed_id}/conversations");
    }
    /**
     * @param {AgentaApi.ReadEmbedConversationRequest} request
     * @param {ChannelsClient.RequestOptions} requestOptions - Request-specific configuration.
     *
     * @throws {@link AgentaApi.UnprocessableEntityError}
     *
     * @example
     *     await client.channels.readEmbedConversation({
     *         embed_id: "embed_id",
     *         thread_id: "thread_id"
     *     })
     */
    readEmbedConversation(request, requestOptions) {
        return core.HttpResponsePromise.fromPromise(this.__readEmbedConversation(request, requestOptions));
    }
    async __readEmbedConversation(request, requestOptions) {
        const { embed_id: embedId, thread_id: threadId } = request;
        const _authRequest = await this._options.authProvider.getAuthRequest();
        const _headers = mergeHeaders(_authRequest.headers, this._options?.headers, requestOptions?.headers);
        const _response = await core.fetcher({
            url: core.url.join((await core.Supplier.get(this._options.baseUrl)) ??
                (await core.Supplier.get(this._options.environment)) ??
                environments.AgentaApiEnvironment.Default, `channels/embed/${core.url.encodePathParam(embedId)}/conversations/${core.url.encodePathParam(threadId)}`),
            method: "GET",
            headers: _headers,
            queryParameters: requestOptions?.queryParams,
            timeoutMs: (requestOptions?.timeoutInSeconds ?? this._options?.timeoutInSeconds ?? 30) * 1000,
            maxRetries: requestOptions?.maxRetries ?? this._options?.maxRetries,
            withCredentials: true,
            abortSignal: requestOptions?.abortSignal,
            fetchFn: this._options?.fetch,
            logging: this._options.logging,
        });
        if (_response.ok) {
            return { data: _response.body, rawResponse: _response.rawResponse };
        }
        if (_response.error.reason === "status-code") {
            switch (_response.error.statusCode) {
                case 422:
                    throw new AgentaApi.UnprocessableEntityError(_response.error.body, _response.rawResponse);
                default:
                    throw new errors.AgentaApiError({
                        statusCode: _response.error.statusCode,
                        body: _response.error.body,
                        rawResponse: _response.rawResponse,
                    });
            }
        }
        return handleNonStatusCodeError(_response.error, _response.rawResponse, "GET", "/channels/embed/{embed_id}/conversations/{thread_id}");
    }
    /**
     * @param {AgentaApi.StreamEmbedConversationRequest} request
     * @param {ChannelsClient.RequestOptions} requestOptions - Request-specific configuration.
     *
     * @throws {@link AgentaApi.UnprocessableEntityError}
     *
     * @example
     *     await client.channels.streamEmbedConversation({
     *         embed_id: "embed_id",
     *         thread_id: "thread_id"
     *     })
     */
    streamEmbedConversation(request, requestOptions) {
        return core.HttpResponsePromise.fromPromise(this.__streamEmbedConversation(request, requestOptions));
    }
    async __streamEmbedConversation(request, requestOptions) {
        const { embed_id: embedId, thread_id: threadId, after } = request;
        const _queryParams = {
            after,
        };
        const _authRequest = await this._options.authProvider.getAuthRequest();
        const _headers = mergeHeaders(_authRequest.headers, this._options?.headers, requestOptions?.headers);
        const _response = await core.fetcher({
            url: core.url.join((await core.Supplier.get(this._options.baseUrl)) ??
                (await core.Supplier.get(this._options.environment)) ??
                environments.AgentaApiEnvironment.Default, `channels/embed/${core.url.encodePathParam(embedId)}/conversations/${core.url.encodePathParam(threadId)}/live`),
            method: "GET",
            headers: _headers,
            queryParameters: { ..._queryParams, ...requestOptions?.queryParams },
            timeoutMs: (requestOptions?.timeoutInSeconds ?? this._options?.timeoutInSeconds ?? 30) * 1000,
            maxRetries: requestOptions?.maxRetries ?? this._options?.maxRetries,
            withCredentials: true,
            abortSignal: requestOptions?.abortSignal,
            fetchFn: this._options?.fetch,
            logging: this._options.logging,
        });
        if (_response.ok) {
            return { data: undefined, rawResponse: _response.rawResponse };
        }
        if (_response.error.reason === "status-code") {
            switch (_response.error.statusCode) {
                case 422:
                    throw new AgentaApi.UnprocessableEntityError(_response.error.body, _response.rawResponse);
                default:
                    throw new errors.AgentaApiError({
                        statusCode: _response.error.statusCode,
                        body: _response.error.body,
                        rawResponse: _response.rawResponse,
                    });
            }
        }
        return handleNonStatusCodeError(_response.error, _response.rawResponse, "GET", "/channels/embed/{embed_id}/conversations/{thread_id}/live");
    }
    /**
     * A session attachment of the caller's thread. The lookup is scoped by
     * the thread's session, so another session's file is not found.
     *
     * @param {AgentaApi.DownloadEmbedFileRequest} request
     * @param {ChannelsClient.RequestOptions} requestOptions - Request-specific configuration.
     *
     * @throws {@link AgentaApi.UnprocessableEntityError}
     *
     * @example
     *     await client.channels.downloadEmbedFile({
     *         embed_id: "embed_id",
     *         thread_id: "thread_id",
     *         file_id: "file_id"
     *     })
     */
    downloadEmbedFile(request, requestOptions) {
        return core.HttpResponsePromise.fromPromise(this.__downloadEmbedFile(request, requestOptions));
    }
    async __downloadEmbedFile(request, requestOptions) {
        const { embed_id: embedId, thread_id: threadId, file_id: fileId } = request;
        const _authRequest = await this._options.authProvider.getAuthRequest();
        const _headers = mergeHeaders(_authRequest.headers, this._options?.headers, requestOptions?.headers);
        const _response = await core.fetcher({
            url: core.url.join((await core.Supplier.get(this._options.baseUrl)) ??
                (await core.Supplier.get(this._options.environment)) ??
                environments.AgentaApiEnvironment.Default, `channels/embed/${core.url.encodePathParam(embedId)}/conversations/${core.url.encodePathParam(threadId)}/files/${core.url.encodePathParam(fileId)}`),
            method: "GET",
            headers: _headers,
            queryParameters: requestOptions?.queryParams,
            timeoutMs: (requestOptions?.timeoutInSeconds ?? this._options?.timeoutInSeconds ?? 30) * 1000,
            maxRetries: requestOptions?.maxRetries ?? this._options?.maxRetries,
            withCredentials: true,
            abortSignal: requestOptions?.abortSignal,
            fetchFn: this._options?.fetch,
            logging: this._options.logging,
        });
        if (_response.ok) {
            return { data: undefined, rawResponse: _response.rawResponse };
        }
        if (_response.error.reason === "status-code") {
            switch (_response.error.statusCode) {
                case 422:
                    throw new AgentaApi.UnprocessableEntityError(_response.error.body, _response.rawResponse);
                default:
                    throw new errors.AgentaApiError({
                        statusCode: _response.error.statusCode,
                        body: _response.error.body,
                        rawResponse: _response.rawResponse,
                    });
            }
        }
        return handleNonStatusCodeError(_response.error, _response.rawResponse, "GET", "/channels/embed/{embed_id}/conversations/{thread_id}/files/{file_id}");
    }
    /**
     * @param {ChannelsClient.RequestOptions} requestOptions - Request-specific configuration.
     *
     * @example
     *     await client.channels.listChannels()
     */
    listChannels(requestOptions) {
        return core.HttpResponsePromise.fromPromise(this.__listChannels(requestOptions));
    }
    async __listChannels(requestOptions) {
        const _authRequest = await this._options.authProvider.getAuthRequest();
        const _headers = mergeHeaders(_authRequest.headers, this._options?.headers, requestOptions?.headers);
        const _response = await core.fetcher({
            url: core.url.join((await core.Supplier.get(this._options.baseUrl)) ??
                (await core.Supplier.get(this._options.environment)) ??
                environments.AgentaApiEnvironment.Default, "channels/catalog/channels/"),
            method: "GET",
            headers: _headers,
            queryParameters: requestOptions?.queryParams,
            timeoutMs: (requestOptions?.timeoutInSeconds ?? this._options?.timeoutInSeconds ?? 30) * 1000,
            maxRetries: requestOptions?.maxRetries ?? this._options?.maxRetries,
            withCredentials: true,
            abortSignal: requestOptions?.abortSignal,
            fetchFn: this._options?.fetch,
            logging: this._options.logging,
        });
        if (_response.ok) {
            return { data: _response.body, rawResponse: _response.rawResponse };
        }
        if (_response.error.reason === "status-code") {
            throw new errors.AgentaApiError({
                statusCode: _response.error.statusCode,
                body: _response.error.body,
                rawResponse: _response.rawResponse,
            });
        }
        return handleNonStatusCodeError(_response.error, _response.rawResponse, "GET", "/channels/catalog/channels/");
    }
    /**
     * @param {AgentaApi.FetchChannelCapabilitiesRequest} request
     * @param {ChannelsClient.RequestOptions} requestOptions - Request-specific configuration.
     *
     * @throws {@link AgentaApi.UnprocessableEntityError}
     *
     * @example
     *     await client.channels.fetchChannelCapabilities({
     *         channel: "channel"
     *     })
     */
    fetchChannelCapabilities(request, requestOptions) {
        return core.HttpResponsePromise.fromPromise(this.__fetchChannelCapabilities(request, requestOptions));
    }
    async __fetchChannelCapabilities(request, requestOptions) {
        const { channel } = request;
        const _authRequest = await this._options.authProvider.getAuthRequest();
        const _headers = mergeHeaders(_authRequest.headers, this._options?.headers, requestOptions?.headers);
        const _response = await core.fetcher({
            url: core.url.join((await core.Supplier.get(this._options.baseUrl)) ??
                (await core.Supplier.get(this._options.environment)) ??
                environments.AgentaApiEnvironment.Default, `channels/catalog/channels/${core.url.encodePathParam(channel)}/capabilities/`),
            method: "GET",
            headers: _headers,
            queryParameters: requestOptions?.queryParams,
            timeoutMs: (requestOptions?.timeoutInSeconds ?? this._options?.timeoutInSeconds ?? 30) * 1000,
            maxRetries: requestOptions?.maxRetries ?? this._options?.maxRetries,
            withCredentials: true,
            abortSignal: requestOptions?.abortSignal,
            fetchFn: this._options?.fetch,
            logging: this._options.logging,
        });
        if (_response.ok) {
            return {
                data: _response.body,
                rawResponse: _response.rawResponse,
            };
        }
        if (_response.error.reason === "status-code") {
            switch (_response.error.statusCode) {
                case 422:
                    throw new AgentaApi.UnprocessableEntityError(_response.error.body, _response.rawResponse);
                default:
                    throw new errors.AgentaApiError({
                        statusCode: _response.error.statusCode,
                        body: _response.error.body,
                        rawResponse: _response.rawResponse,
                    });
            }
        }
        return handleNonStatusCodeError(_response.error, _response.rawResponse, "GET", "/channels/catalog/channels/{channel}/capabilities/");
    }
    /**
     * Reachable before any connection exists -- the manifest an
     * operator needs to go build the platform app in the first place.
     * `fetch_channel_connection_setup` stays the route for a connection
     * that already exists; this is the one that precedes it.
     *
     * `name`, `description` and `handle` are how the app the operator
     * builds presents itself; the adapter defaults and fits each one.
     *
     * @param {AgentaApi.FetchChannelSetupRequest} request
     * @param {ChannelsClient.RequestOptions} requestOptions - Request-specific configuration.
     *
     * @throws {@link AgentaApi.UnprocessableEntityError}
     *
     * @example
     *     await client.channels.fetchChannelSetup({
     *         channel: "channel"
     *     })
     */
    fetchChannelSetup(request, requestOptions) {
        return core.HttpResponsePromise.fromPromise(this.__fetchChannelSetup(request, requestOptions));
    }
    async __fetchChannelSetup(request, requestOptions) {
        const { channel, name, description, handle } = request;
        const _queryParams = {
            name,
            description,
            handle,
        };
        const _authRequest = await this._options.authProvider.getAuthRequest();
        const _headers = mergeHeaders(_authRequest.headers, this._options?.headers, requestOptions?.headers);
        const _response = await core.fetcher({
            url: core.url.join((await core.Supplier.get(this._options.baseUrl)) ??
                (await core.Supplier.get(this._options.environment)) ??
                environments.AgentaApiEnvironment.Default, `channels/catalog/channels/${core.url.encodePathParam(channel)}/setup/`),
            method: "GET",
            headers: _headers,
            queryParameters: { ..._queryParams, ...requestOptions?.queryParams },
            timeoutMs: (requestOptions?.timeoutInSeconds ?? this._options?.timeoutInSeconds ?? 30) * 1000,
            maxRetries: requestOptions?.maxRetries ?? this._options?.maxRetries,
            withCredentials: true,
            abortSignal: requestOptions?.abortSignal,
            fetchFn: this._options?.fetch,
            logging: this._options.logging,
        });
        if (_response.ok) {
            return { data: _response.body, rawResponse: _response.rawResponse };
        }
        if (_response.error.reason === "status-code") {
            switch (_response.error.statusCode) {
                case 422:
                    throw new AgentaApi.UnprocessableEntityError(_response.error.body, _response.rawResponse);
                default:
                    throw new errors.AgentaApiError({
                        statusCode: _response.error.statusCode,
                        body: _response.error.body,
                        rawResponse: _response.rawResponse,
                    });
            }
        }
        return handleNonStatusCodeError(_response.error, _response.rawResponse, "GET", "/channels/catalog/channels/{channel}/setup/");
    }
    /**
     * One click, from Settings -> Channels: mint the install state and
     * send the browser straight to Slack's authorize URL. A deployment
     * with no hosted-app credentials refuses here, not with a 500 -- that
     * is the normal shape of a self-hosted deployment, not an error.
     *
     * @param {ChannelsClient.RequestOptions} requestOptions - Request-specific configuration.
     *
     * @example
     *     await client.channels.installSlackConnection()
     */
    installSlackConnection(requestOptions) {
        return core.HttpResponsePromise.fromPromise(this.__installSlackConnection(requestOptions));
    }
    async __installSlackConnection(requestOptions) {
        const _authRequest = await this._options.authProvider.getAuthRequest();
        const _headers = mergeHeaders(_authRequest.headers, this._options?.headers, requestOptions?.headers);
        const _response = await core.fetcher({
            url: core.url.join((await core.Supplier.get(this._options.baseUrl)) ??
                (await core.Supplier.get(this._options.environment)) ??
                environments.AgentaApiEnvironment.Default, "channels/catalog/channels/slack/install/"),
            method: "GET",
            headers: _headers,
            queryParameters: requestOptions?.queryParams,
            timeoutMs: (requestOptions?.timeoutInSeconds ?? this._options?.timeoutInSeconds ?? 30) * 1000,
            maxRetries: requestOptions?.maxRetries ?? this._options?.maxRetries,
            withCredentials: true,
            abortSignal: requestOptions?.abortSignal,
            fetchFn: this._options?.fetch,
            logging: this._options.logging,
        });
        if (_response.ok) {
            return { data: _response.body, rawResponse: _response.rawResponse };
        }
        if (_response.error.reason === "status-code") {
            throw new errors.AgentaApiError({
                statusCode: _response.error.statusCode,
                body: _response.error.body,
                rawResponse: _response.rawResponse,
            });
        }
        return handleNonStatusCodeError(_response.error, _response.rawResponse, "GET", "/channels/catalog/channels/slack/install/");
    }
    /**
     * Slack redirects the browser here, in or out of the session that
     * started the install -- the signed state is the whole of the
     * authorisation on this route, so this is public (see
     * `_PUBLIC_ENDPOINTS`), never `self._check`. State decodes first:
     * unknown, expired or tampered refuses before any exchange is
     * attempted.
     *
     * @param {AgentaApi.SlackInstallCallbackRequest} request
     * @param {ChannelsClient.RequestOptions} requestOptions - Request-specific configuration.
     *
     * @throws {@link AgentaApi.UnprocessableEntityError}
     *
     * @example
     *     await client.channels.slackInstallCallback()
     */
    slackInstallCallback(request = {}, requestOptions) {
        return core.HttpResponsePromise.fromPromise(this.__slackInstallCallback(request, requestOptions));
    }
    async __slackInstallCallback(request = {}, requestOptions) {
        const { code, state, error } = request;
        const _queryParams = {
            code,
            state,
            error,
        };
        const _authRequest = await this._options.authProvider.getAuthRequest();
        const _headers = mergeHeaders(_authRequest.headers, this._options?.headers, requestOptions?.headers);
        const _response = await core.fetcher({
            url: core.url.join((await core.Supplier.get(this._options.baseUrl)) ??
                (await core.Supplier.get(this._options.environment)) ??
                environments.AgentaApiEnvironment.Default, "channels/catalog/channels/slack/callback/"),
            method: "GET",
            headers: _headers,
            queryParameters: { ..._queryParams, ...requestOptions?.queryParams },
            timeoutMs: (requestOptions?.timeoutInSeconds ?? this._options?.timeoutInSeconds ?? 30) * 1000,
            maxRetries: requestOptions?.maxRetries ?? this._options?.maxRetries,
            withCredentials: true,
            abortSignal: requestOptions?.abortSignal,
            fetchFn: this._options?.fetch,
            logging: this._options.logging,
        });
        if (_response.ok) {
            return { data: _response.body, rawResponse: _response.rawResponse };
        }
        if (_response.error.reason === "status-code") {
            switch (_response.error.statusCode) {
                case 422:
                    throw new AgentaApi.UnprocessableEntityError(_response.error.body, _response.rawResponse);
                default:
                    throw new errors.AgentaApiError({
                        statusCode: _response.error.statusCode,
                        body: _response.error.body,
                        rawResponse: _response.rawResponse,
                    });
            }
        }
        return handleNonStatusCodeError(_response.error, _response.rawResponse, "GET", "/channels/catalog/channels/slack/callback/");
    }
    /**
     * Prepare the hosted Telegram connection and its agent, then mint the
     * one-time deep link the connect UI shows. 404 when the deployment has no
     * hosted bot configured.
     *
     * @param {AgentaApi.TelegramHostedBindLinkRequest} request
     * @param {ChannelsClient.RequestOptions} requestOptions - Request-specific configuration.
     *
     * @throws {@link AgentaApi.UnprocessableEntityError}
     *
     * @example
     *     await client.channels.createTelegramHostedBindLink({
     *         references: {
     *             "key": "value"
     *         }
     *     })
     */
    createTelegramHostedBindLink(request, requestOptions) {
        return core.HttpResponsePromise.fromPromise(this.__createTelegramHostedBindLink(request, requestOptions));
    }
    async __createTelegramHostedBindLink(request, requestOptions) {
        const _authRequest = await this._options.authProvider.getAuthRequest();
        const _headers = mergeHeaders(_authRequest.headers, this._options?.headers, requestOptions?.headers);
        const _response = await core.fetcher({
            url: core.url.join((await core.Supplier.get(this._options.baseUrl)) ??
                (await core.Supplier.get(this._options.environment)) ??
                environments.AgentaApiEnvironment.Default, "channels/catalog/channels/telegram_hosted/bind-link/"),
            method: "POST",
            headers: _headers,
            contentType: "application/json",
            queryParameters: requestOptions?.queryParams,
            requestType: "json",
            body: request,
            timeoutMs: (requestOptions?.timeoutInSeconds ?? this._options?.timeoutInSeconds ?? 30) * 1000,
            maxRetries: requestOptions?.maxRetries ?? this._options?.maxRetries,
            withCredentials: true,
            abortSignal: requestOptions?.abortSignal,
            fetchFn: this._options?.fetch,
            logging: this._options.logging,
        });
        if (_response.ok) {
            return {
                data: _response.body,
                rawResponse: _response.rawResponse,
            };
        }
        if (_response.error.reason === "status-code") {
            switch (_response.error.statusCode) {
                case 422:
                    throw new AgentaApi.UnprocessableEntityError(_response.error.body, _response.rawResponse);
                default:
                    throw new errors.AgentaApiError({
                        statusCode: _response.error.statusCode,
                        body: _response.error.body,
                        rawResponse: _response.rawResponse,
                    });
            }
        }
        return handleNonStatusCodeError(_response.error, _response.rawResponse, "POST", "/channels/catalog/channels/telegram_hosted/bind-link/");
    }
    /**
     * The chats bound to a hosted Telegram connection in this project.
     * Empty until a /start consumed a bind token. 404 when the deployment has
     * no hosted bot configured.
     *
     * @param {AgentaApi.ListTelegramHostedBindingsRequest} request
     * @param {ChannelsClient.RequestOptions} requestOptions - Request-specific configuration.
     *
     * @throws {@link AgentaApi.UnprocessableEntityError}
     *
     * @example
     *     await client.channels.listTelegramHostedBindings({
     *         connection_id: "connection_id"
     *     })
     */
    listTelegramHostedBindings(request, requestOptions) {
        return core.HttpResponsePromise.fromPromise(this.__listTelegramHostedBindings(request, requestOptions));
    }
    async __listTelegramHostedBindings(request, requestOptions) {
        const { connection_id: connectionId } = request;
        const _queryParams = {
            connection_id: connectionId,
        };
        const _authRequest = await this._options.authProvider.getAuthRequest();
        const _headers = mergeHeaders(_authRequest.headers, this._options?.headers, requestOptions?.headers);
        const _response = await core.fetcher({
            url: core.url.join((await core.Supplier.get(this._options.baseUrl)) ??
                (await core.Supplier.get(this._options.environment)) ??
                environments.AgentaApiEnvironment.Default, "channels/catalog/channels/telegram_hosted/bindings/"),
            method: "GET",
            headers: _headers,
            queryParameters: { ..._queryParams, ...requestOptions?.queryParams },
            timeoutMs: (requestOptions?.timeoutInSeconds ?? this._options?.timeoutInSeconds ?? 30) * 1000,
            maxRetries: requestOptions?.maxRetries ?? this._options?.maxRetries,
            withCredentials: true,
            abortSignal: requestOptions?.abortSignal,
            fetchFn: this._options?.fetch,
            logging: this._options.logging,
        });
        if (_response.ok) {
            return {
                data: _response.body,
                rawResponse: _response.rawResponse,
            };
        }
        if (_response.error.reason === "status-code") {
            switch (_response.error.statusCode) {
                case 422:
                    throw new AgentaApi.UnprocessableEntityError(_response.error.body, _response.rawResponse);
                default:
                    throw new errors.AgentaApiError({
                        statusCode: _response.error.statusCode,
                        body: _response.error.body,
                        rawResponse: _response.rawResponse,
                    });
            }
        }
        return handleNonStatusCodeError(_response.error, _response.rawResponse, "GET", "/channels/catalog/channels/telegram_hosted/bindings/");
    }
    /**
     * @param {AgentaApi.ChannelConnectionRequest} request
     * @param {ChannelsClient.RequestOptions} requestOptions - Request-specific configuration.
     *
     * @throws {@link AgentaApi.UnprocessableEntityError}
     *
     * @example
     *     await client.channels.createChannelConnection({
     *         connection: {
     *             channel: "channel"
     *         }
     *     })
     */
    createChannelConnection(request, requestOptions) {
        return core.HttpResponsePromise.fromPromise(this.__createChannelConnection(request, requestOptions));
    }
    async __createChannelConnection(request, requestOptions) {
        const _authRequest = await this._options.authProvider.getAuthRequest();
        const _headers = mergeHeaders(_authRequest.headers, this._options?.headers, requestOptions?.headers);
        const _response = await core.fetcher({
            url: core.url.join((await core.Supplier.get(this._options.baseUrl)) ??
                (await core.Supplier.get(this._options.environment)) ??
                environments.AgentaApiEnvironment.Default, "channels/connections/"),
            method: "POST",
            headers: _headers,
            contentType: "application/json",
            queryParameters: requestOptions?.queryParams,
            requestType: "json",
            body: request,
            timeoutMs: (requestOptions?.timeoutInSeconds ?? this._options?.timeoutInSeconds ?? 30) * 1000,
            maxRetries: requestOptions?.maxRetries ?? this._options?.maxRetries,
            withCredentials: true,
            abortSignal: requestOptions?.abortSignal,
            fetchFn: this._options?.fetch,
            logging: this._options.logging,
        });
        if (_response.ok) {
            return { data: _response.body, rawResponse: _response.rawResponse };
        }
        if (_response.error.reason === "status-code") {
            switch (_response.error.statusCode) {
                case 422:
                    throw new AgentaApi.UnprocessableEntityError(_response.error.body, _response.rawResponse);
                default:
                    throw new errors.AgentaApiError({
                        statusCode: _response.error.statusCode,
                        body: _response.error.body,
                        rawResponse: _response.rawResponse,
                    });
            }
        }
        return handleNonStatusCodeError(_response.error, _response.rawResponse, "POST", "/channels/connections/");
    }
    /**
     * @param {AgentaApi.ChannelConnectionQueryRequest} request
     * @param {ChannelsClient.RequestOptions} requestOptions - Request-specific configuration.
     *
     * @throws {@link AgentaApi.UnprocessableEntityError}
     *
     * @example
     *     await client.channels.queryChannelConnections()
     */
    queryChannelConnections(request = {}, requestOptions) {
        return core.HttpResponsePromise.fromPromise(this.__queryChannelConnections(request, requestOptions));
    }
    async __queryChannelConnections(request = {}, requestOptions) {
        const _authRequest = await this._options.authProvider.getAuthRequest();
        const _headers = mergeHeaders(_authRequest.headers, this._options?.headers, requestOptions?.headers);
        const _response = await core.fetcher({
            url: core.url.join((await core.Supplier.get(this._options.baseUrl)) ??
                (await core.Supplier.get(this._options.environment)) ??
                environments.AgentaApiEnvironment.Default, "channels/connections/query"),
            method: "POST",
            headers: _headers,
            contentType: "application/json",
            queryParameters: requestOptions?.queryParams,
            requestType: "json",
            body: request,
            timeoutMs: (requestOptions?.timeoutInSeconds ?? this._options?.timeoutInSeconds ?? 30) * 1000,
            maxRetries: requestOptions?.maxRetries ?? this._options?.maxRetries,
            withCredentials: true,
            abortSignal: requestOptions?.abortSignal,
            fetchFn: this._options?.fetch,
            logging: this._options.logging,
        });
        if (_response.ok) {
            return { data: _response.body, rawResponse: _response.rawResponse };
        }
        if (_response.error.reason === "status-code") {
            switch (_response.error.statusCode) {
                case 422:
                    throw new AgentaApi.UnprocessableEntityError(_response.error.body, _response.rawResponse);
                default:
                    throw new errors.AgentaApiError({
                        statusCode: _response.error.statusCode,
                        body: _response.error.body,
                        rawResponse: _response.rawResponse,
                    });
            }
        }
        return handleNonStatusCodeError(_response.error, _response.rawResponse, "POST", "/channels/connections/query");
    }
    /**
     * @param {AgentaApi.ChannelConnectionEditRequest} request
     * @param {ChannelsClient.RequestOptions} requestOptions - Request-specific configuration.
     *
     * @throws {@link AgentaApi.UnprocessableEntityError}
     *
     * @example
     *     await client.channels.editChannelConnection({
     *         connection_id: "connection_id",
     *         connection: {}
     *     })
     */
    editChannelConnection(request, requestOptions) {
        return core.HttpResponsePromise.fromPromise(this.__editChannelConnection(request, requestOptions));
    }
    async __editChannelConnection(request, requestOptions) {
        const { connection_id: connectionId, ..._body } = request;
        const _authRequest = await this._options.authProvider.getAuthRequest();
        const _headers = mergeHeaders(_authRequest.headers, this._options?.headers, requestOptions?.headers);
        const _response = await core.fetcher({
            url: core.url.join((await core.Supplier.get(this._options.baseUrl)) ??
                (await core.Supplier.get(this._options.environment)) ??
                environments.AgentaApiEnvironment.Default, `channels/connections/${core.url.encodePathParam(connectionId)}/edit`),
            method: "POST",
            headers: _headers,
            contentType: "application/json",
            queryParameters: requestOptions?.queryParams,
            requestType: "json",
            body: _body,
            timeoutMs: (requestOptions?.timeoutInSeconds ?? this._options?.timeoutInSeconds ?? 30) * 1000,
            maxRetries: requestOptions?.maxRetries ?? this._options?.maxRetries,
            withCredentials: true,
            abortSignal: requestOptions?.abortSignal,
            fetchFn: this._options?.fetch,
            logging: this._options.logging,
        });
        if (_response.ok) {
            return { data: _response.body, rawResponse: _response.rawResponse };
        }
        if (_response.error.reason === "status-code") {
            switch (_response.error.statusCode) {
                case 422:
                    throw new AgentaApi.UnprocessableEntityError(_response.error.body, _response.rawResponse);
                default:
                    throw new errors.AgentaApiError({
                        statusCode: _response.error.statusCode,
                        body: _response.error.body,
                        rawResponse: _response.rawResponse,
                    });
            }
        }
        return handleNonStatusCodeError(_response.error, _response.rawResponse, "POST", "/channels/connections/{connection_id}/edit");
    }
    /**
     * @param {AgentaApi.ArchiveChannelConnectionRequest} request
     * @param {ChannelsClient.RequestOptions} requestOptions - Request-specific configuration.
     *
     * @throws {@link AgentaApi.UnprocessableEntityError}
     *
     * @example
     *     await client.channels.archiveChannelConnection({
     *         connection_id: "connection_id"
     *     })
     */
    archiveChannelConnection(request, requestOptions) {
        return core.HttpResponsePromise.fromPromise(this.__archiveChannelConnection(request, requestOptions));
    }
    async __archiveChannelConnection(request, requestOptions) {
        const { connection_id: connectionId } = request;
        const _authRequest = await this._options.authProvider.getAuthRequest();
        const _headers = mergeHeaders(_authRequest.headers, this._options?.headers, requestOptions?.headers);
        const _response = await core.fetcher({
            url: core.url.join((await core.Supplier.get(this._options.baseUrl)) ??
                (await core.Supplier.get(this._options.environment)) ??
                environments.AgentaApiEnvironment.Default, `channels/connections/${core.url.encodePathParam(connectionId)}/archive`),
            method: "POST",
            headers: _headers,
            queryParameters: requestOptions?.queryParams,
            timeoutMs: (requestOptions?.timeoutInSeconds ?? this._options?.timeoutInSeconds ?? 30) * 1000,
            maxRetries: requestOptions?.maxRetries ?? this._options?.maxRetries,
            withCredentials: true,
            abortSignal: requestOptions?.abortSignal,
            fetchFn: this._options?.fetch,
            logging: this._options.logging,
        });
        if (_response.ok) {
            return {
                data: _response.body,
                rawResponse: _response.rawResponse,
            };
        }
        if (_response.error.reason === "status-code") {
            switch (_response.error.statusCode) {
                case 422:
                    throw new AgentaApi.UnprocessableEntityError(_response.error.body, _response.rawResponse);
                default:
                    throw new errors.AgentaApiError({
                        statusCode: _response.error.statusCode,
                        body: _response.error.body,
                        rawResponse: _response.rawResponse,
                    });
            }
        }
        return handleNonStatusCodeError(_response.error, _response.rawResponse, "POST", "/channels/connections/{connection_id}/archive");
    }
    /**
     * @param {AgentaApi.UnarchiveChannelConnectionRequest} request
     * @param {ChannelsClient.RequestOptions} requestOptions - Request-specific configuration.
     *
     * @throws {@link AgentaApi.UnprocessableEntityError}
     *
     * @example
     *     await client.channels.unarchiveChannelConnection({
     *         connection_id: "connection_id"
     *     })
     */
    unarchiveChannelConnection(request, requestOptions) {
        return core.HttpResponsePromise.fromPromise(this.__unarchiveChannelConnection(request, requestOptions));
    }
    async __unarchiveChannelConnection(request, requestOptions) {
        const { connection_id: connectionId } = request;
        const _authRequest = await this._options.authProvider.getAuthRequest();
        const _headers = mergeHeaders(_authRequest.headers, this._options?.headers, requestOptions?.headers);
        const _response = await core.fetcher({
            url: core.url.join((await core.Supplier.get(this._options.baseUrl)) ??
                (await core.Supplier.get(this._options.environment)) ??
                environments.AgentaApiEnvironment.Default, `channels/connections/${core.url.encodePathParam(connectionId)}/unarchive`),
            method: "POST",
            headers: _headers,
            queryParameters: requestOptions?.queryParams,
            timeoutMs: (requestOptions?.timeoutInSeconds ?? this._options?.timeoutInSeconds ?? 30) * 1000,
            maxRetries: requestOptions?.maxRetries ?? this._options?.maxRetries,
            withCredentials: true,
            abortSignal: requestOptions?.abortSignal,
            fetchFn: this._options?.fetch,
            logging: this._options.logging,
        });
        if (_response.ok) {
            return {
                data: _response.body,
                rawResponse: _response.rawResponse,
            };
        }
        if (_response.error.reason === "status-code") {
            switch (_response.error.statusCode) {
                case 422:
                    throw new AgentaApi.UnprocessableEntityError(_response.error.body, _response.rawResponse);
                default:
                    throw new errors.AgentaApiError({
                        statusCode: _response.error.statusCode,
                        body: _response.error.body,
                        rawResponse: _response.rawResponse,
                    });
            }
        }
        return handleNonStatusCodeError(_response.error, _response.rawResponse, "POST", "/channels/connections/{connection_id}/unarchive");
    }
    /**
     * @param {AgentaApi.FetchChannelConnectionSetupRequest} request
     * @param {ChannelsClient.RequestOptions} requestOptions - Request-specific configuration.
     *
     * @throws {@link AgentaApi.UnprocessableEntityError}
     *
     * @example
     *     await client.channels.fetchChannelConnectionSetup({
     *         connection_id: "connection_id"
     *     })
     */
    fetchChannelConnectionSetup(request, requestOptions) {
        return core.HttpResponsePromise.fromPromise(this.__fetchChannelConnectionSetup(request, requestOptions));
    }
    async __fetchChannelConnectionSetup(request, requestOptions) {
        const { connection_id: connectionId } = request;
        const _authRequest = await this._options.authProvider.getAuthRequest();
        const _headers = mergeHeaders(_authRequest.headers, this._options?.headers, requestOptions?.headers);
        const _response = await core.fetcher({
            url: core.url.join((await core.Supplier.get(this._options.baseUrl)) ??
                (await core.Supplier.get(this._options.environment)) ??
                environments.AgentaApiEnvironment.Default, `channels/connections/${core.url.encodePathParam(connectionId)}/setup`),
            method: "GET",
            headers: _headers,
            queryParameters: requestOptions?.queryParams,
            timeoutMs: (requestOptions?.timeoutInSeconds ?? this._options?.timeoutInSeconds ?? 30) * 1000,
            maxRetries: requestOptions?.maxRetries ?? this._options?.maxRetries,
            withCredentials: true,
            abortSignal: requestOptions?.abortSignal,
            fetchFn: this._options?.fetch,
            logging: this._options.logging,
        });
        if (_response.ok) {
            return {
                data: _response.body,
                rawResponse: _response.rawResponse,
            };
        }
        if (_response.error.reason === "status-code") {
            switch (_response.error.statusCode) {
                case 422:
                    throw new AgentaApi.UnprocessableEntityError(_response.error.body, _response.rawResponse);
                default:
                    throw new errors.AgentaApiError({
                        statusCode: _response.error.statusCode,
                        body: _response.error.body,
                        rawResponse: _response.rawResponse,
                    });
            }
        }
        return handleNonStatusCodeError(_response.error, _response.rawResponse, "GET", "/channels/connections/{connection_id}/setup");
    }
    /**
     * @param {ChannelsClient.RequestOptions} requestOptions - Request-specific configuration.
     *
     * @example
     *     await client.channels.listChannelAgents()
     */
    listChannelAgents(requestOptions) {
        return core.HttpResponsePromise.fromPromise(this.__listChannelAgents(requestOptions));
    }
    async __listChannelAgents(requestOptions) {
        const _authRequest = await this._options.authProvider.getAuthRequest();
        const _headers = mergeHeaders(_authRequest.headers, this._options?.headers, requestOptions?.headers);
        const _response = await core.fetcher({
            url: core.url.join((await core.Supplier.get(this._options.baseUrl)) ??
                (await core.Supplier.get(this._options.environment)) ??
                environments.AgentaApiEnvironment.Default, "channels/agents/"),
            method: "GET",
            headers: _headers,
            queryParameters: requestOptions?.queryParams,
            timeoutMs: (requestOptions?.timeoutInSeconds ?? this._options?.timeoutInSeconds ?? 30) * 1000,
            maxRetries: requestOptions?.maxRetries ?? this._options?.maxRetries,
            withCredentials: true,
            abortSignal: requestOptions?.abortSignal,
            fetchFn: this._options?.fetch,
            logging: this._options.logging,
        });
        if (_response.ok) {
            return { data: _response.body, rawResponse: _response.rawResponse };
        }
        if (_response.error.reason === "status-code") {
            throw new errors.AgentaApiError({
                statusCode: _response.error.statusCode,
                body: _response.error.body,
                rawResponse: _response.rawResponse,
            });
        }
        return handleNonStatusCodeError(_response.error, _response.rawResponse, "GET", "/channels/agents/");
    }
    /**
     * @param {AgentaApi.ChannelAgentRequest} request
     * @param {ChannelsClient.RequestOptions} requestOptions - Request-specific configuration.
     *
     * @throws {@link AgentaApi.UnprocessableEntityError}
     *
     * @example
     *     await client.channels.createChannelAgent({
     *         agent: {
     *             connection_id: "connection_id",
     *             data: {
     *                 references: {
     *                     "key": {}
     *                 }
     *             }
     *         }
     *     })
     */
    createChannelAgent(request, requestOptions) {
        return core.HttpResponsePromise.fromPromise(this.__createChannelAgent(request, requestOptions));
    }
    async __createChannelAgent(request, requestOptions) {
        const _authRequest = await this._options.authProvider.getAuthRequest();
        const _headers = mergeHeaders(_authRequest.headers, this._options?.headers, requestOptions?.headers);
        const _response = await core.fetcher({
            url: core.url.join((await core.Supplier.get(this._options.baseUrl)) ??
                (await core.Supplier.get(this._options.environment)) ??
                environments.AgentaApiEnvironment.Default, "channels/agents/"),
            method: "POST",
            headers: _headers,
            contentType: "application/json",
            queryParameters: requestOptions?.queryParams,
            requestType: "json",
            body: request,
            timeoutMs: (requestOptions?.timeoutInSeconds ?? this._options?.timeoutInSeconds ?? 30) * 1000,
            maxRetries: requestOptions?.maxRetries ?? this._options?.maxRetries,
            withCredentials: true,
            abortSignal: requestOptions?.abortSignal,
            fetchFn: this._options?.fetch,
            logging: this._options.logging,
        });
        if (_response.ok) {
            return { data: _response.body, rawResponse: _response.rawResponse };
        }
        if (_response.error.reason === "status-code") {
            switch (_response.error.statusCode) {
                case 422:
                    throw new AgentaApi.UnprocessableEntityError(_response.error.body, _response.rawResponse);
                default:
                    throw new errors.AgentaApiError({
                        statusCode: _response.error.statusCode,
                        body: _response.error.body,
                        rawResponse: _response.rawResponse,
                    });
            }
        }
        return handleNonStatusCodeError(_response.error, _response.rawResponse, "POST", "/channels/agents/");
    }
    /**
     * @param {AgentaApi.ChannelAgentQueryRequest} request
     * @param {ChannelsClient.RequestOptions} requestOptions - Request-specific configuration.
     *
     * @throws {@link AgentaApi.UnprocessableEntityError}
     *
     * @example
     *     await client.channels.queryChannelAgents()
     */
    queryChannelAgents(request = {}, requestOptions) {
        return core.HttpResponsePromise.fromPromise(this.__queryChannelAgents(request, requestOptions));
    }
    async __queryChannelAgents(request = {}, requestOptions) {
        const _authRequest = await this._options.authProvider.getAuthRequest();
        const _headers = mergeHeaders(_authRequest.headers, this._options?.headers, requestOptions?.headers);
        const _response = await core.fetcher({
            url: core.url.join((await core.Supplier.get(this._options.baseUrl)) ??
                (await core.Supplier.get(this._options.environment)) ??
                environments.AgentaApiEnvironment.Default, "channels/agents/query"),
            method: "POST",
            headers: _headers,
            contentType: "application/json",
            queryParameters: requestOptions?.queryParams,
            requestType: "json",
            body: request,
            timeoutMs: (requestOptions?.timeoutInSeconds ?? this._options?.timeoutInSeconds ?? 30) * 1000,
            maxRetries: requestOptions?.maxRetries ?? this._options?.maxRetries,
            withCredentials: true,
            abortSignal: requestOptions?.abortSignal,
            fetchFn: this._options?.fetch,
            logging: this._options.logging,
        });
        if (_response.ok) {
            return { data: _response.body, rawResponse: _response.rawResponse };
        }
        if (_response.error.reason === "status-code") {
            switch (_response.error.statusCode) {
                case 422:
                    throw new AgentaApi.UnprocessableEntityError(_response.error.body, _response.rawResponse);
                default:
                    throw new errors.AgentaApiError({
                        statusCode: _response.error.statusCode,
                        body: _response.error.body,
                        rawResponse: _response.rawResponse,
                    });
            }
        }
        return handleNonStatusCodeError(_response.error, _response.rawResponse, "POST", "/channels/agents/query");
    }
    /**
     * @param {AgentaApi.FetchChannelAgentRequest} request
     * @param {ChannelsClient.RequestOptions} requestOptions - Request-specific configuration.
     *
     * @throws {@link AgentaApi.UnprocessableEntityError}
     *
     * @example
     *     await client.channels.fetchChannelAgent({
     *         agent_id: "agent_id"
     *     })
     */
    fetchChannelAgent(request, requestOptions) {
        return core.HttpResponsePromise.fromPromise(this.__fetchChannelAgent(request, requestOptions));
    }
    async __fetchChannelAgent(request, requestOptions) {
        const { agent_id: agentId } = request;
        const _authRequest = await this._options.authProvider.getAuthRequest();
        const _headers = mergeHeaders(_authRequest.headers, this._options?.headers, requestOptions?.headers);
        const _response = await core.fetcher({
            url: core.url.join((await core.Supplier.get(this._options.baseUrl)) ??
                (await core.Supplier.get(this._options.environment)) ??
                environments.AgentaApiEnvironment.Default, `channels/agents/${core.url.encodePathParam(agentId)}`),
            method: "GET",
            headers: _headers,
            queryParameters: requestOptions?.queryParams,
            timeoutMs: (requestOptions?.timeoutInSeconds ?? this._options?.timeoutInSeconds ?? 30) * 1000,
            maxRetries: requestOptions?.maxRetries ?? this._options?.maxRetries,
            withCredentials: true,
            abortSignal: requestOptions?.abortSignal,
            fetchFn: this._options?.fetch,
            logging: this._options.logging,
        });
        if (_response.ok) {
            return { data: _response.body, rawResponse: _response.rawResponse };
        }
        if (_response.error.reason === "status-code") {
            switch (_response.error.statusCode) {
                case 422:
                    throw new AgentaApi.UnprocessableEntityError(_response.error.body, _response.rawResponse);
                default:
                    throw new errors.AgentaApiError({
                        statusCode: _response.error.statusCode,
                        body: _response.error.body,
                        rawResponse: _response.rawResponse,
                    });
            }
        }
        return handleNonStatusCodeError(_response.error, _response.rawResponse, "GET", "/channels/agents/{agent_id}");
    }
    /**
     * @param {AgentaApi.ChannelAgentEditRequest} request
     * @param {ChannelsClient.RequestOptions} requestOptions - Request-specific configuration.
     *
     * @throws {@link AgentaApi.UnprocessableEntityError}
     *
     * @example
     *     await client.channels.editChannelAgent({
     *         agent_id: "agent_id",
     *         agent: {}
     *     })
     */
    editChannelAgent(request, requestOptions) {
        return core.HttpResponsePromise.fromPromise(this.__editChannelAgent(request, requestOptions));
    }
    async __editChannelAgent(request, requestOptions) {
        const { agent_id: agentId, ..._body } = request;
        const _authRequest = await this._options.authProvider.getAuthRequest();
        const _headers = mergeHeaders(_authRequest.headers, this._options?.headers, requestOptions?.headers);
        const _response = await core.fetcher({
            url: core.url.join((await core.Supplier.get(this._options.baseUrl)) ??
                (await core.Supplier.get(this._options.environment)) ??
                environments.AgentaApiEnvironment.Default, `channels/agents/${core.url.encodePathParam(agentId)}`),
            method: "PUT",
            headers: _headers,
            contentType: "application/json",
            queryParameters: requestOptions?.queryParams,
            requestType: "json",
            body: _body,
            timeoutMs: (requestOptions?.timeoutInSeconds ?? this._options?.timeoutInSeconds ?? 30) * 1000,
            maxRetries: requestOptions?.maxRetries ?? this._options?.maxRetries,
            withCredentials: true,
            abortSignal: requestOptions?.abortSignal,
            fetchFn: this._options?.fetch,
            logging: this._options.logging,
        });
        if (_response.ok) {
            return { data: _response.body, rawResponse: _response.rawResponse };
        }
        if (_response.error.reason === "status-code") {
            switch (_response.error.statusCode) {
                case 422:
                    throw new AgentaApi.UnprocessableEntityError(_response.error.body, _response.rawResponse);
                default:
                    throw new errors.AgentaApiError({
                        statusCode: _response.error.statusCode,
                        body: _response.error.body,
                        rawResponse: _response.rawResponse,
                    });
            }
        }
        return handleNonStatusCodeError(_response.error, _response.rawResponse, "PUT", "/channels/agents/{agent_id}");
    }
    /**
     * @param {AgentaApi.DeleteChannelAgentRequest} request
     * @param {ChannelsClient.RequestOptions} requestOptions - Request-specific configuration.
     *
     * @throws {@link AgentaApi.UnprocessableEntityError}
     *
     * @example
     *     await client.channels.deleteChannelAgent({
     *         agent_id: "agent_id"
     *     })
     */
    deleteChannelAgent(request, requestOptions) {
        return core.HttpResponsePromise.fromPromise(this.__deleteChannelAgent(request, requestOptions));
    }
    async __deleteChannelAgent(request, requestOptions) {
        const { agent_id: agentId } = request;
        const _authRequest = await this._options.authProvider.getAuthRequest();
        const _headers = mergeHeaders(_authRequest.headers, this._options?.headers, requestOptions?.headers);
        const _response = await core.fetcher({
            url: core.url.join((await core.Supplier.get(this._options.baseUrl)) ??
                (await core.Supplier.get(this._options.environment)) ??
                environments.AgentaApiEnvironment.Default, `channels/agents/${core.url.encodePathParam(agentId)}`),
            method: "DELETE",
            headers: _headers,
            queryParameters: requestOptions?.queryParams,
            timeoutMs: (requestOptions?.timeoutInSeconds ?? this._options?.timeoutInSeconds ?? 30) * 1000,
            maxRetries: requestOptions?.maxRetries ?? this._options?.maxRetries,
            withCredentials: true,
            abortSignal: requestOptions?.abortSignal,
            fetchFn: this._options?.fetch,
            logging: this._options.logging,
        });
        if (_response.ok) {
            return { data: undefined, rawResponse: _response.rawResponse };
        }
        if (_response.error.reason === "status-code") {
            switch (_response.error.statusCode) {
                case 422:
                    throw new AgentaApi.UnprocessableEntityError(_response.error.body, _response.rawResponse);
                default:
                    throw new errors.AgentaApiError({
                        statusCode: _response.error.statusCode,
                        body: _response.error.body,
                        rawResponse: _response.rawResponse,
                    });
            }
        }
        return handleNonStatusCodeError(_response.error, _response.rawResponse, "DELETE", "/channels/agents/{agent_id}");
    }
    /**
     * @param {AgentaApi.SetChannelAgentDefaultRequest} request
     * @param {ChannelsClient.RequestOptions} requestOptions - Request-specific configuration.
     *
     * @throws {@link AgentaApi.UnprocessableEntityError}
     *
     * @example
     *     await client.channels.setChannelAgentDefault({
     *         agent_id: "agent_id"
     *     })
     */
    setChannelAgentDefault(request, requestOptions) {
        return core.HttpResponsePromise.fromPromise(this.__setChannelAgentDefault(request, requestOptions));
    }
    async __setChannelAgentDefault(request, requestOptions) {
        const { agent_id: agentId } = request;
        const _authRequest = await this._options.authProvider.getAuthRequest();
        const _headers = mergeHeaders(_authRequest.headers, this._options?.headers, requestOptions?.headers);
        const _response = await core.fetcher({
            url: core.url.join((await core.Supplier.get(this._options.baseUrl)) ??
                (await core.Supplier.get(this._options.environment)) ??
                environments.AgentaApiEnvironment.Default, `channels/agents/${core.url.encodePathParam(agentId)}/default`),
            method: "POST",
            headers: _headers,
            queryParameters: requestOptions?.queryParams,
            timeoutMs: (requestOptions?.timeoutInSeconds ?? this._options?.timeoutInSeconds ?? 30) * 1000,
            maxRetries: requestOptions?.maxRetries ?? this._options?.maxRetries,
            withCredentials: true,
            abortSignal: requestOptions?.abortSignal,
            fetchFn: this._options?.fetch,
            logging: this._options.logging,
        });
        if (_response.ok) {
            return { data: _response.body, rawResponse: _response.rawResponse };
        }
        if (_response.error.reason === "status-code") {
            switch (_response.error.statusCode) {
                case 422:
                    throw new AgentaApi.UnprocessableEntityError(_response.error.body, _response.rawResponse);
                default:
                    throw new errors.AgentaApiError({
                        statusCode: _response.error.statusCode,
                        body: _response.error.body,
                        rawResponse: _response.rawResponse,
                    });
            }
        }
        return handleNonStatusCodeError(_response.error, _response.rawResponse, "POST", "/channels/agents/{agent_id}/default");
    }
    /**
     * @param {ChannelsClient.RequestOptions} requestOptions - Request-specific configuration.
     *
     * @example
     *     await client.channels.listChannelSpaces()
     */
    listChannelSpaces(requestOptions) {
        return core.HttpResponsePromise.fromPromise(this.__listChannelSpaces(requestOptions));
    }
    async __listChannelSpaces(requestOptions) {
        const _authRequest = await this._options.authProvider.getAuthRequest();
        const _headers = mergeHeaders(_authRequest.headers, this._options?.headers, requestOptions?.headers);
        const _response = await core.fetcher({
            url: core.url.join((await core.Supplier.get(this._options.baseUrl)) ??
                (await core.Supplier.get(this._options.environment)) ??
                environments.AgentaApiEnvironment.Default, "channels/spaces/"),
            method: "GET",
            headers: _headers,
            queryParameters: requestOptions?.queryParams,
            timeoutMs: (requestOptions?.timeoutInSeconds ?? this._options?.timeoutInSeconds ?? 30) * 1000,
            maxRetries: requestOptions?.maxRetries ?? this._options?.maxRetries,
            withCredentials: true,
            abortSignal: requestOptions?.abortSignal,
            fetchFn: this._options?.fetch,
            logging: this._options.logging,
        });
        if (_response.ok) {
            return { data: _response.body, rawResponse: _response.rawResponse };
        }
        if (_response.error.reason === "status-code") {
            throw new errors.AgentaApiError({
                statusCode: _response.error.statusCode,
                body: _response.error.body,
                rawResponse: _response.rawResponse,
            });
        }
        return handleNonStatusCodeError(_response.error, _response.rawResponse, "GET", "/channels/spaces/");
    }
    /**
     * @param {AgentaApi.ChannelSpaceRequest} request
     * @param {ChannelsClient.RequestOptions} requestOptions - Request-specific configuration.
     *
     * @throws {@link AgentaApi.UnprocessableEntityError}
     *
     * @example
     *     await client.channels.createChannelSpace({
     *         space: {
     *             connection_id: "connection_id",
     *             kind: "private",
     *             external_key: "external_key",
     *             data: {
     *                 external_locator: {
     *                     "key": "value"
     *                 }
     *             }
     *         }
     *     })
     */
    createChannelSpace(request, requestOptions) {
        return core.HttpResponsePromise.fromPromise(this.__createChannelSpace(request, requestOptions));
    }
    async __createChannelSpace(request, requestOptions) {
        const _authRequest = await this._options.authProvider.getAuthRequest();
        const _headers = mergeHeaders(_authRequest.headers, this._options?.headers, requestOptions?.headers);
        const _response = await core.fetcher({
            url: core.url.join((await core.Supplier.get(this._options.baseUrl)) ??
                (await core.Supplier.get(this._options.environment)) ??
                environments.AgentaApiEnvironment.Default, "channels/spaces/"),
            method: "POST",
            headers: _headers,
            contentType: "application/json",
            queryParameters: requestOptions?.queryParams,
            requestType: "json",
            body: request,
            timeoutMs: (requestOptions?.timeoutInSeconds ?? this._options?.timeoutInSeconds ?? 30) * 1000,
            maxRetries: requestOptions?.maxRetries ?? this._options?.maxRetries,
            withCredentials: true,
            abortSignal: requestOptions?.abortSignal,
            fetchFn: this._options?.fetch,
            logging: this._options.logging,
        });
        if (_response.ok) {
            return { data: _response.body, rawResponse: _response.rawResponse };
        }
        if (_response.error.reason === "status-code") {
            switch (_response.error.statusCode) {
                case 422:
                    throw new AgentaApi.UnprocessableEntityError(_response.error.body, _response.rawResponse);
                default:
                    throw new errors.AgentaApiError({
                        statusCode: _response.error.statusCode,
                        body: _response.error.body,
                        rawResponse: _response.rawResponse,
                    });
            }
        }
        return handleNonStatusCodeError(_response.error, _response.rawResponse, "POST", "/channels/spaces/");
    }
    /**
     * @param {AgentaApi.ChannelSpaceQueryRequest} request
     * @param {ChannelsClient.RequestOptions} requestOptions - Request-specific configuration.
     *
     * @throws {@link AgentaApi.UnprocessableEntityError}
     *
     * @example
     *     await client.channels.queryChannelSpaces()
     */
    queryChannelSpaces(request = {}, requestOptions) {
        return core.HttpResponsePromise.fromPromise(this.__queryChannelSpaces(request, requestOptions));
    }
    async __queryChannelSpaces(request = {}, requestOptions) {
        const _authRequest = await this._options.authProvider.getAuthRequest();
        const _headers = mergeHeaders(_authRequest.headers, this._options?.headers, requestOptions?.headers);
        const _response = await core.fetcher({
            url: core.url.join((await core.Supplier.get(this._options.baseUrl)) ??
                (await core.Supplier.get(this._options.environment)) ??
                environments.AgentaApiEnvironment.Default, "channels/spaces/query"),
            method: "POST",
            headers: _headers,
            contentType: "application/json",
            queryParameters: requestOptions?.queryParams,
            requestType: "json",
            body: request,
            timeoutMs: (requestOptions?.timeoutInSeconds ?? this._options?.timeoutInSeconds ?? 30) * 1000,
            maxRetries: requestOptions?.maxRetries ?? this._options?.maxRetries,
            withCredentials: true,
            abortSignal: requestOptions?.abortSignal,
            fetchFn: this._options?.fetch,
            logging: this._options.logging,
        });
        if (_response.ok) {
            return { data: _response.body, rawResponse: _response.rawResponse };
        }
        if (_response.error.reason === "status-code") {
            switch (_response.error.statusCode) {
                case 422:
                    throw new AgentaApi.UnprocessableEntityError(_response.error.body, _response.rawResponse);
                default:
                    throw new errors.AgentaApiError({
                        statusCode: _response.error.statusCode,
                        body: _response.error.body,
                        rawResponse: _response.rawResponse,
                    });
            }
        }
        return handleNonStatusCodeError(_response.error, _response.rawResponse, "POST", "/channels/spaces/query");
    }
    /**
     * @param {AgentaApi.ChannelSpaceDiscoverRequest} request
     * @param {ChannelsClient.RequestOptions} requestOptions - Request-specific configuration.
     *
     * @throws {@link AgentaApi.UnprocessableEntityError}
     *
     * @example
     *     await client.channels.discoverChannelSpaces({
     *         connection_id: "connection_id"
     *     })
     */
    discoverChannelSpaces(request, requestOptions) {
        return core.HttpResponsePromise.fromPromise(this.__discoverChannelSpaces(request, requestOptions));
    }
    async __discoverChannelSpaces(request, requestOptions) {
        const _authRequest = await this._options.authProvider.getAuthRequest();
        const _headers = mergeHeaders(_authRequest.headers, this._options?.headers, requestOptions?.headers);
        const _response = await core.fetcher({
            url: core.url.join((await core.Supplier.get(this._options.baseUrl)) ??
                (await core.Supplier.get(this._options.environment)) ??
                environments.AgentaApiEnvironment.Default, "channels/spaces/discover"),
            method: "POST",
            headers: _headers,
            contentType: "application/json",
            queryParameters: requestOptions?.queryParams,
            requestType: "json",
            body: request,
            timeoutMs: (requestOptions?.timeoutInSeconds ?? this._options?.timeoutInSeconds ?? 30) * 1000,
            maxRetries: requestOptions?.maxRetries ?? this._options?.maxRetries,
            withCredentials: true,
            abortSignal: requestOptions?.abortSignal,
            fetchFn: this._options?.fetch,
            logging: this._options.logging,
        });
        if (_response.ok) {
            return {
                data: _response.body,
                rawResponse: _response.rawResponse,
            };
        }
        if (_response.error.reason === "status-code") {
            switch (_response.error.statusCode) {
                case 422:
                    throw new AgentaApi.UnprocessableEntityError(_response.error.body, _response.rawResponse);
                default:
                    throw new errors.AgentaApiError({
                        statusCode: _response.error.statusCode,
                        body: _response.error.body,
                        rawResponse: _response.rawResponse,
                    });
            }
        }
        return handleNonStatusCodeError(_response.error, _response.rawResponse, "POST", "/channels/spaces/discover");
    }
    /**
     * @param {AgentaApi.FetchChannelSpaceRequest} request
     * @param {ChannelsClient.RequestOptions} requestOptions - Request-specific configuration.
     *
     * @throws {@link AgentaApi.UnprocessableEntityError}
     *
     * @example
     *     await client.channels.fetchChannelSpace({
     *         space_id: "space_id"
     *     })
     */
    fetchChannelSpace(request, requestOptions) {
        return core.HttpResponsePromise.fromPromise(this.__fetchChannelSpace(request, requestOptions));
    }
    async __fetchChannelSpace(request, requestOptions) {
        const { space_id: spaceId } = request;
        const _authRequest = await this._options.authProvider.getAuthRequest();
        const _headers = mergeHeaders(_authRequest.headers, this._options?.headers, requestOptions?.headers);
        const _response = await core.fetcher({
            url: core.url.join((await core.Supplier.get(this._options.baseUrl)) ??
                (await core.Supplier.get(this._options.environment)) ??
                environments.AgentaApiEnvironment.Default, `channels/spaces/${core.url.encodePathParam(spaceId)}`),
            method: "GET",
            headers: _headers,
            queryParameters: requestOptions?.queryParams,
            timeoutMs: (requestOptions?.timeoutInSeconds ?? this._options?.timeoutInSeconds ?? 30) * 1000,
            maxRetries: requestOptions?.maxRetries ?? this._options?.maxRetries,
            withCredentials: true,
            abortSignal: requestOptions?.abortSignal,
            fetchFn: this._options?.fetch,
            logging: this._options.logging,
        });
        if (_response.ok) {
            return { data: _response.body, rawResponse: _response.rawResponse };
        }
        if (_response.error.reason === "status-code") {
            switch (_response.error.statusCode) {
                case 422:
                    throw new AgentaApi.UnprocessableEntityError(_response.error.body, _response.rawResponse);
                default:
                    throw new errors.AgentaApiError({
                        statusCode: _response.error.statusCode,
                        body: _response.error.body,
                        rawResponse: _response.rawResponse,
                    });
            }
        }
        return handleNonStatusCodeError(_response.error, _response.rawResponse, "GET", "/channels/spaces/{space_id}");
    }
    /**
     * @param {AgentaApi.ChannelSpaceEditRequest} request
     * @param {ChannelsClient.RequestOptions} requestOptions - Request-specific configuration.
     *
     * @throws {@link AgentaApi.UnprocessableEntityError}
     *
     * @example
     *     await client.channels.editChannelSpace({
     *         space_id: "space_id",
     *         space: {
     *             data: {
     *                 external_locator: {
     *                     "key": "value"
     *                 }
     *             }
     *         }
     *     })
     */
    editChannelSpace(request, requestOptions) {
        return core.HttpResponsePromise.fromPromise(this.__editChannelSpace(request, requestOptions));
    }
    async __editChannelSpace(request, requestOptions) {
        const { space_id: spaceId, ..._body } = request;
        const _authRequest = await this._options.authProvider.getAuthRequest();
        const _headers = mergeHeaders(_authRequest.headers, this._options?.headers, requestOptions?.headers);
        const _response = await core.fetcher({
            url: core.url.join((await core.Supplier.get(this._options.baseUrl)) ??
                (await core.Supplier.get(this._options.environment)) ??
                environments.AgentaApiEnvironment.Default, `channels/spaces/${core.url.encodePathParam(spaceId)}`),
            method: "PUT",
            headers: _headers,
            contentType: "application/json",
            queryParameters: requestOptions?.queryParams,
            requestType: "json",
            body: _body,
            timeoutMs: (requestOptions?.timeoutInSeconds ?? this._options?.timeoutInSeconds ?? 30) * 1000,
            maxRetries: requestOptions?.maxRetries ?? this._options?.maxRetries,
            withCredentials: true,
            abortSignal: requestOptions?.abortSignal,
            fetchFn: this._options?.fetch,
            logging: this._options.logging,
        });
        if (_response.ok) {
            return { data: _response.body, rawResponse: _response.rawResponse };
        }
        if (_response.error.reason === "status-code") {
            switch (_response.error.statusCode) {
                case 422:
                    throw new AgentaApi.UnprocessableEntityError(_response.error.body, _response.rawResponse);
                default:
                    throw new errors.AgentaApiError({
                        statusCode: _response.error.statusCode,
                        body: _response.error.body,
                        rawResponse: _response.rawResponse,
                    });
            }
        }
        return handleNonStatusCodeError(_response.error, _response.rawResponse, "PUT", "/channels/spaces/{space_id}");
    }
    /**
     * @param {AgentaApi.DeleteChannelSpaceRequest} request
     * @param {ChannelsClient.RequestOptions} requestOptions - Request-specific configuration.
     *
     * @throws {@link AgentaApi.UnprocessableEntityError}
     *
     * @example
     *     await client.channels.deleteChannelSpace({
     *         space_id: "space_id"
     *     })
     */
    deleteChannelSpace(request, requestOptions) {
        return core.HttpResponsePromise.fromPromise(this.__deleteChannelSpace(request, requestOptions));
    }
    async __deleteChannelSpace(request, requestOptions) {
        const { space_id: spaceId } = request;
        const _authRequest = await this._options.authProvider.getAuthRequest();
        const _headers = mergeHeaders(_authRequest.headers, this._options?.headers, requestOptions?.headers);
        const _response = await core.fetcher({
            url: core.url.join((await core.Supplier.get(this._options.baseUrl)) ??
                (await core.Supplier.get(this._options.environment)) ??
                environments.AgentaApiEnvironment.Default, `channels/spaces/${core.url.encodePathParam(spaceId)}`),
            method: "DELETE",
            headers: _headers,
            queryParameters: requestOptions?.queryParams,
            timeoutMs: (requestOptions?.timeoutInSeconds ?? this._options?.timeoutInSeconds ?? 30) * 1000,
            maxRetries: requestOptions?.maxRetries ?? this._options?.maxRetries,
            withCredentials: true,
            abortSignal: requestOptions?.abortSignal,
            fetchFn: this._options?.fetch,
            logging: this._options.logging,
        });
        if (_response.ok) {
            return { data: undefined, rawResponse: _response.rawResponse };
        }
        if (_response.error.reason === "status-code") {
            switch (_response.error.statusCode) {
                case 422:
                    throw new AgentaApi.UnprocessableEntityError(_response.error.body, _response.rawResponse);
                default:
                    throw new errors.AgentaApiError({
                        statusCode: _response.error.statusCode,
                        body: _response.error.body,
                        rawResponse: _response.rawResponse,
                    });
            }
        }
        return handleNonStatusCodeError(_response.error, _response.rawResponse, "DELETE", "/channels/spaces/{space_id}");
    }
    /**
     * @param {ChannelsClient.RequestOptions} requestOptions - Request-specific configuration.
     *
     * @example
     *     await client.channels.listChannelGrants()
     */
    listChannelGrants(requestOptions) {
        return core.HttpResponsePromise.fromPromise(this.__listChannelGrants(requestOptions));
    }
    async __listChannelGrants(requestOptions) {
        const _authRequest = await this._options.authProvider.getAuthRequest();
        const _headers = mergeHeaders(_authRequest.headers, this._options?.headers, requestOptions?.headers);
        const _response = await core.fetcher({
            url: core.url.join((await core.Supplier.get(this._options.baseUrl)) ??
                (await core.Supplier.get(this._options.environment)) ??
                environments.AgentaApiEnvironment.Default, "channels/grants/"),
            method: "GET",
            headers: _headers,
            queryParameters: requestOptions?.queryParams,
            timeoutMs: (requestOptions?.timeoutInSeconds ?? this._options?.timeoutInSeconds ?? 30) * 1000,
            maxRetries: requestOptions?.maxRetries ?? this._options?.maxRetries,
            withCredentials: true,
            abortSignal: requestOptions?.abortSignal,
            fetchFn: this._options?.fetch,
            logging: this._options.logging,
        });
        if (_response.ok) {
            return { data: _response.body, rawResponse: _response.rawResponse };
        }
        if (_response.error.reason === "status-code") {
            throw new errors.AgentaApiError({
                statusCode: _response.error.statusCode,
                body: _response.error.body,
                rawResponse: _response.rawResponse,
            });
        }
        return handleNonStatusCodeError(_response.error, _response.rawResponse, "GET", "/channels/grants/");
    }
    /**
     * @param {AgentaApi.ChannelGrantRequest} request
     * @param {ChannelsClient.RequestOptions} requestOptions - Request-specific configuration.
     *
     * @throws {@link AgentaApi.UnprocessableEntityError}
     *
     * @example
     *     await client.channels.createChannelGrant({
     *         grant: {
     *             agent_id: "agent_id",
     *             effect: "allow",
     *             data: {}
     *         }
     *     })
     */
    createChannelGrant(request, requestOptions) {
        return core.HttpResponsePromise.fromPromise(this.__createChannelGrant(request, requestOptions));
    }
    async __createChannelGrant(request, requestOptions) {
        const _authRequest = await this._options.authProvider.getAuthRequest();
        const _headers = mergeHeaders(_authRequest.headers, this._options?.headers, requestOptions?.headers);
        const _response = await core.fetcher({
            url: core.url.join((await core.Supplier.get(this._options.baseUrl)) ??
                (await core.Supplier.get(this._options.environment)) ??
                environments.AgentaApiEnvironment.Default, "channels/grants/"),
            method: "POST",
            headers: _headers,
            contentType: "application/json",
            queryParameters: requestOptions?.queryParams,
            requestType: "json",
            body: request,
            timeoutMs: (requestOptions?.timeoutInSeconds ?? this._options?.timeoutInSeconds ?? 30) * 1000,
            maxRetries: requestOptions?.maxRetries ?? this._options?.maxRetries,
            withCredentials: true,
            abortSignal: requestOptions?.abortSignal,
            fetchFn: this._options?.fetch,
            logging: this._options.logging,
        });
        if (_response.ok) {
            return { data: _response.body, rawResponse: _response.rawResponse };
        }
        if (_response.error.reason === "status-code") {
            switch (_response.error.statusCode) {
                case 422:
                    throw new AgentaApi.UnprocessableEntityError(_response.error.body, _response.rawResponse);
                default:
                    throw new errors.AgentaApiError({
                        statusCode: _response.error.statusCode,
                        body: _response.error.body,
                        rawResponse: _response.rawResponse,
                    });
            }
        }
        return handleNonStatusCodeError(_response.error, _response.rawResponse, "POST", "/channels/grants/");
    }
    /**
     * @param {AgentaApi.ChannelGrantQueryRequest} request
     * @param {ChannelsClient.RequestOptions} requestOptions - Request-specific configuration.
     *
     * @throws {@link AgentaApi.UnprocessableEntityError}
     *
     * @example
     *     await client.channels.queryChannelGrants()
     */
    queryChannelGrants(request = {}, requestOptions) {
        return core.HttpResponsePromise.fromPromise(this.__queryChannelGrants(request, requestOptions));
    }
    async __queryChannelGrants(request = {}, requestOptions) {
        const _authRequest = await this._options.authProvider.getAuthRequest();
        const _headers = mergeHeaders(_authRequest.headers, this._options?.headers, requestOptions?.headers);
        const _response = await core.fetcher({
            url: core.url.join((await core.Supplier.get(this._options.baseUrl)) ??
                (await core.Supplier.get(this._options.environment)) ??
                environments.AgentaApiEnvironment.Default, "channels/grants/query"),
            method: "POST",
            headers: _headers,
            contentType: "application/json",
            queryParameters: requestOptions?.queryParams,
            requestType: "json",
            body: request,
            timeoutMs: (requestOptions?.timeoutInSeconds ?? this._options?.timeoutInSeconds ?? 30) * 1000,
            maxRetries: requestOptions?.maxRetries ?? this._options?.maxRetries,
            withCredentials: true,
            abortSignal: requestOptions?.abortSignal,
            fetchFn: this._options?.fetch,
            logging: this._options.logging,
        });
        if (_response.ok) {
            return { data: _response.body, rawResponse: _response.rawResponse };
        }
        if (_response.error.reason === "status-code") {
            switch (_response.error.statusCode) {
                case 422:
                    throw new AgentaApi.UnprocessableEntityError(_response.error.body, _response.rawResponse);
                default:
                    throw new errors.AgentaApiError({
                        statusCode: _response.error.statusCode,
                        body: _response.error.body,
                        rawResponse: _response.rawResponse,
                    });
            }
        }
        return handleNonStatusCodeError(_response.error, _response.rawResponse, "POST", "/channels/grants/query");
    }
    /**
     * @param {AgentaApi.ChannelGrantEditRequest} request
     * @param {ChannelsClient.RequestOptions} requestOptions - Request-specific configuration.
     *
     * @throws {@link AgentaApi.UnprocessableEntityError}
     *
     * @example
     *     await client.channels.editChannelGrant({
     *         grant_id: "grant_id",
     *         grant: {
     *             data: {}
     *         }
     *     })
     */
    editChannelGrant(request, requestOptions) {
        return core.HttpResponsePromise.fromPromise(this.__editChannelGrant(request, requestOptions));
    }
    async __editChannelGrant(request, requestOptions) {
        const { grant_id: grantId, ..._body } = request;
        const _authRequest = await this._options.authProvider.getAuthRequest();
        const _headers = mergeHeaders(_authRequest.headers, this._options?.headers, requestOptions?.headers);
        const _response = await core.fetcher({
            url: core.url.join((await core.Supplier.get(this._options.baseUrl)) ??
                (await core.Supplier.get(this._options.environment)) ??
                environments.AgentaApiEnvironment.Default, `channels/grants/${core.url.encodePathParam(grantId)}`),
            method: "PUT",
            headers: _headers,
            contentType: "application/json",
            queryParameters: requestOptions?.queryParams,
            requestType: "json",
            body: _body,
            timeoutMs: (requestOptions?.timeoutInSeconds ?? this._options?.timeoutInSeconds ?? 30) * 1000,
            maxRetries: requestOptions?.maxRetries ?? this._options?.maxRetries,
            withCredentials: true,
            abortSignal: requestOptions?.abortSignal,
            fetchFn: this._options?.fetch,
            logging: this._options.logging,
        });
        if (_response.ok) {
            return { data: _response.body, rawResponse: _response.rawResponse };
        }
        if (_response.error.reason === "status-code") {
            switch (_response.error.statusCode) {
                case 422:
                    throw new AgentaApi.UnprocessableEntityError(_response.error.body, _response.rawResponse);
                default:
                    throw new errors.AgentaApiError({
                        statusCode: _response.error.statusCode,
                        body: _response.error.body,
                        rawResponse: _response.rawResponse,
                    });
            }
        }
        return handleNonStatusCodeError(_response.error, _response.rawResponse, "PUT", "/channels/grants/{grant_id}");
    }
    /**
     * @param {AgentaApi.DeleteChannelGrantRequest} request
     * @param {ChannelsClient.RequestOptions} requestOptions - Request-specific configuration.
     *
     * @throws {@link AgentaApi.UnprocessableEntityError}
     *
     * @example
     *     await client.channels.deleteChannelGrant({
     *         grant_id: "grant_id"
     *     })
     */
    deleteChannelGrant(request, requestOptions) {
        return core.HttpResponsePromise.fromPromise(this.__deleteChannelGrant(request, requestOptions));
    }
    async __deleteChannelGrant(request, requestOptions) {
        const { grant_id: grantId } = request;
        const _authRequest = await this._options.authProvider.getAuthRequest();
        const _headers = mergeHeaders(_authRequest.headers, this._options?.headers, requestOptions?.headers);
        const _response = await core.fetcher({
            url: core.url.join((await core.Supplier.get(this._options.baseUrl)) ??
                (await core.Supplier.get(this._options.environment)) ??
                environments.AgentaApiEnvironment.Default, `channels/grants/${core.url.encodePathParam(grantId)}`),
            method: "DELETE",
            headers: _headers,
            queryParameters: requestOptions?.queryParams,
            timeoutMs: (requestOptions?.timeoutInSeconds ?? this._options?.timeoutInSeconds ?? 30) * 1000,
            maxRetries: requestOptions?.maxRetries ?? this._options?.maxRetries,
            withCredentials: true,
            abortSignal: requestOptions?.abortSignal,
            fetchFn: this._options?.fetch,
            logging: this._options.logging,
        });
        if (_response.ok) {
            return { data: undefined, rawResponse: _response.rawResponse };
        }
        if (_response.error.reason === "status-code") {
            switch (_response.error.statusCode) {
                case 422:
                    throw new AgentaApi.UnprocessableEntityError(_response.error.body, _response.rawResponse);
                default:
                    throw new errors.AgentaApiError({
                        statusCode: _response.error.statusCode,
                        body: _response.error.body,
                        rawResponse: _response.rawResponse,
                    });
            }
        }
        return handleNonStatusCodeError(_response.error, _response.rawResponse, "DELETE", "/channels/grants/{grant_id}");
    }
    /**
     * @param {AgentaApi.SetChannelGrantDefaultRequest} request
     * @param {ChannelsClient.RequestOptions} requestOptions - Request-specific configuration.
     *
     * @throws {@link AgentaApi.UnprocessableEntityError}
     *
     * @example
     *     await client.channels.setChannelGrantDefault({
     *         grant_id: "grant_id"
     *     })
     */
    setChannelGrantDefault(request, requestOptions) {
        return core.HttpResponsePromise.fromPromise(this.__setChannelGrantDefault(request, requestOptions));
    }
    async __setChannelGrantDefault(request, requestOptions) {
        const { grant_id: grantId } = request;
        const _authRequest = await this._options.authProvider.getAuthRequest();
        const _headers = mergeHeaders(_authRequest.headers, this._options?.headers, requestOptions?.headers);
        const _response = await core.fetcher({
            url: core.url.join((await core.Supplier.get(this._options.baseUrl)) ??
                (await core.Supplier.get(this._options.environment)) ??
                environments.AgentaApiEnvironment.Default, `channels/grants/${core.url.encodePathParam(grantId)}/default`),
            method: "POST",
            headers: _headers,
            queryParameters: requestOptions?.queryParams,
            timeoutMs: (requestOptions?.timeoutInSeconds ?? this._options?.timeoutInSeconds ?? 30) * 1000,
            maxRetries: requestOptions?.maxRetries ?? this._options?.maxRetries,
            withCredentials: true,
            abortSignal: requestOptions?.abortSignal,
            fetchFn: this._options?.fetch,
            logging: this._options.logging,
        });
        if (_response.ok) {
            return { data: _response.body, rawResponse: _response.rawResponse };
        }
        if (_response.error.reason === "status-code") {
            switch (_response.error.statusCode) {
                case 422:
                    throw new AgentaApi.UnprocessableEntityError(_response.error.body, _response.rawResponse);
                default:
                    throw new errors.AgentaApiError({
                        statusCode: _response.error.statusCode,
                        body: _response.error.body,
                        rawResponse: _response.rawResponse,
                    });
            }
        }
        return handleNonStatusCodeError(_response.error, _response.rawResponse, "POST", "/channels/grants/{grant_id}/default");
    }
    /**
     * @param {AgentaApi.ChannelPolicyResolveRequest} request
     * @param {ChannelsClient.RequestOptions} requestOptions - Request-specific configuration.
     *
     * @throws {@link AgentaApi.UnprocessableEntityError}
     *
     * @example
     *     await client.channels.resolveChannelPolicy({
     *         agent_id: "agent_id",
     *         space_id: "space_id"
     *     })
     */
    resolveChannelPolicy(request, requestOptions) {
        return core.HttpResponsePromise.fromPromise(this.__resolveChannelPolicy(request, requestOptions));
    }
    async __resolveChannelPolicy(request, requestOptions) {
        const _authRequest = await this._options.authProvider.getAuthRequest();
        const _headers = mergeHeaders(_authRequest.headers, this._options?.headers, requestOptions?.headers);
        const _response = await core.fetcher({
            url: core.url.join((await core.Supplier.get(this._options.baseUrl)) ??
                (await core.Supplier.get(this._options.environment)) ??
                environments.AgentaApiEnvironment.Default, "channels/policy/resolve"),
            method: "POST",
            headers: _headers,
            contentType: "application/json",
            queryParameters: requestOptions?.queryParams,
            requestType: "json",
            body: request,
            timeoutMs: (requestOptions?.timeoutInSeconds ?? this._options?.timeoutInSeconds ?? 30) * 1000,
            maxRetries: requestOptions?.maxRetries ?? this._options?.maxRetries,
            withCredentials: true,
            abortSignal: requestOptions?.abortSignal,
            fetchFn: this._options?.fetch,
            logging: this._options.logging,
        });
        if (_response.ok) {
            return { data: _response.body, rawResponse: _response.rawResponse };
        }
        if (_response.error.reason === "status-code") {
            switch (_response.error.statusCode) {
                case 422:
                    throw new AgentaApi.UnprocessableEntityError(_response.error.body, _response.rawResponse);
                default:
                    throw new errors.AgentaApiError({
                        statusCode: _response.error.statusCode,
                        body: _response.error.body,
                        rawResponse: _response.rawResponse,
                    });
            }
        }
        return handleNonStatusCodeError(_response.error, _response.rawResponse, "POST", "/channels/policy/resolve");
    }
    /**
     * @param {AgentaApi.ChannelThreadQueryRequest} request
     * @param {ChannelsClient.RequestOptions} requestOptions - Request-specific configuration.
     *
     * @throws {@link AgentaApi.UnprocessableEntityError}
     *
     * @example
     *     await client.channels.queryChannelThreads()
     */
    queryChannelThreads(request = {}, requestOptions) {
        return core.HttpResponsePromise.fromPromise(this.__queryChannelThreads(request, requestOptions));
    }
    async __queryChannelThreads(request = {}, requestOptions) {
        const _authRequest = await this._options.authProvider.getAuthRequest();
        const _headers = mergeHeaders(_authRequest.headers, this._options?.headers, requestOptions?.headers);
        const _response = await core.fetcher({
            url: core.url.join((await core.Supplier.get(this._options.baseUrl)) ??
                (await core.Supplier.get(this._options.environment)) ??
                environments.AgentaApiEnvironment.Default, "channels/threads/query"),
            method: "POST",
            headers: _headers,
            contentType: "application/json",
            queryParameters: requestOptions?.queryParams,
            requestType: "json",
            body: request,
            timeoutMs: (requestOptions?.timeoutInSeconds ?? this._options?.timeoutInSeconds ?? 30) * 1000,
            maxRetries: requestOptions?.maxRetries ?? this._options?.maxRetries,
            withCredentials: true,
            abortSignal: requestOptions?.abortSignal,
            fetchFn: this._options?.fetch,
            logging: this._options.logging,
        });
        if (_response.ok) {
            return { data: _response.body, rawResponse: _response.rawResponse };
        }
        if (_response.error.reason === "status-code") {
            switch (_response.error.statusCode) {
                case 422:
                    throw new AgentaApi.UnprocessableEntityError(_response.error.body, _response.rawResponse);
                default:
                    throw new errors.AgentaApiError({
                        statusCode: _response.error.statusCode,
                        body: _response.error.body,
                        rawResponse: _response.rawResponse,
                    });
            }
        }
        return handleNonStatusCodeError(_response.error, _response.rawResponse, "POST", "/channels/threads/query");
    }
    /**
     * @param {AgentaApi.CloseChannelThreadRequest} request
     * @param {ChannelsClient.RequestOptions} requestOptions - Request-specific configuration.
     *
     * @throws {@link AgentaApi.UnprocessableEntityError}
     *
     * @example
     *     await client.channels.closeChannelThread({
     *         thread_id: "thread_id"
     *     })
     */
    closeChannelThread(request, requestOptions) {
        return core.HttpResponsePromise.fromPromise(this.__closeChannelThread(request, requestOptions));
    }
    async __closeChannelThread(request, requestOptions) {
        const { thread_id: threadId } = request;
        const _authRequest = await this._options.authProvider.getAuthRequest();
        const _headers = mergeHeaders(_authRequest.headers, this._options?.headers, requestOptions?.headers);
        const _response = await core.fetcher({
            url: core.url.join((await core.Supplier.get(this._options.baseUrl)) ??
                (await core.Supplier.get(this._options.environment)) ??
                environments.AgentaApiEnvironment.Default, `channels/threads/${core.url.encodePathParam(threadId)}/close`),
            method: "POST",
            headers: _headers,
            queryParameters: requestOptions?.queryParams,
            timeoutMs: (requestOptions?.timeoutInSeconds ?? this._options?.timeoutInSeconds ?? 30) * 1000,
            maxRetries: requestOptions?.maxRetries ?? this._options?.maxRetries,
            withCredentials: true,
            abortSignal: requestOptions?.abortSignal,
            fetchFn: this._options?.fetch,
            logging: this._options.logging,
        });
        if (_response.ok) {
            return { data: _response.body, rawResponse: _response.rawResponse };
        }
        if (_response.error.reason === "status-code") {
            switch (_response.error.statusCode) {
                case 422:
                    throw new AgentaApi.UnprocessableEntityError(_response.error.body, _response.rawResponse);
                default:
                    throw new errors.AgentaApiError({
                        statusCode: _response.error.statusCode,
                        body: _response.error.body,
                        rawResponse: _response.rawResponse,
                    });
            }
        }
        return handleNonStatusCodeError(_response.error, _response.rawResponse, "POST", "/channels/threads/{thread_id}/close");
    }
    /**
     * @param {AgentaApi.ChannelInboxEventQueryRequest} request
     * @param {ChannelsClient.RequestOptions} requestOptions - Request-specific configuration.
     *
     * @throws {@link AgentaApi.UnprocessableEntityError}
     *
     * @example
     *     await client.channels.queryChannelInboxEvents()
     */
    queryChannelInboxEvents(request = {}, requestOptions) {
        return core.HttpResponsePromise.fromPromise(this.__queryChannelInboxEvents(request, requestOptions));
    }
    async __queryChannelInboxEvents(request = {}, requestOptions) {
        const _authRequest = await this._options.authProvider.getAuthRequest();
        const _headers = mergeHeaders(_authRequest.headers, this._options?.headers, requestOptions?.headers);
        const _response = await core.fetcher({
            url: core.url.join((await core.Supplier.get(this._options.baseUrl)) ??
                (await core.Supplier.get(this._options.environment)) ??
                environments.AgentaApiEnvironment.Default, "channels/inbox/events/query"),
            method: "POST",
            headers: _headers,
            contentType: "application/json",
            queryParameters: requestOptions?.queryParams,
            requestType: "json",
            body: request,
            timeoutMs: (requestOptions?.timeoutInSeconds ?? this._options?.timeoutInSeconds ?? 30) * 1000,
            maxRetries: requestOptions?.maxRetries ?? this._options?.maxRetries,
            withCredentials: true,
            abortSignal: requestOptions?.abortSignal,
            fetchFn: this._options?.fetch,
            logging: this._options.logging,
        });
        if (_response.ok) {
            return { data: _response.body, rawResponse: _response.rawResponse };
        }
        if (_response.error.reason === "status-code") {
            switch (_response.error.statusCode) {
                case 422:
                    throw new AgentaApi.UnprocessableEntityError(_response.error.body, _response.rawResponse);
                default:
                    throw new errors.AgentaApiError({
                        statusCode: _response.error.statusCode,
                        body: _response.error.body,
                        rawResponse: _response.rawResponse,
                    });
            }
        }
        return handleNonStatusCodeError(_response.error, _response.rawResponse, "POST", "/channels/inbox/events/query");
    }
    /**
     * @param {AgentaApi.ChannelOutboxEventQueryRequest} request
     * @param {ChannelsClient.RequestOptions} requestOptions - Request-specific configuration.
     *
     * @throws {@link AgentaApi.UnprocessableEntityError}
     *
     * @example
     *     await client.channels.queryChannelOutboxEvents()
     */
    queryChannelOutboxEvents(request = {}, requestOptions) {
        return core.HttpResponsePromise.fromPromise(this.__queryChannelOutboxEvents(request, requestOptions));
    }
    async __queryChannelOutboxEvents(request = {}, requestOptions) {
        const _authRequest = await this._options.authProvider.getAuthRequest();
        const _headers = mergeHeaders(_authRequest.headers, this._options?.headers, requestOptions?.headers);
        const _response = await core.fetcher({
            url: core.url.join((await core.Supplier.get(this._options.baseUrl)) ??
                (await core.Supplier.get(this._options.environment)) ??
                environments.AgentaApiEnvironment.Default, "channels/outbox/events/query"),
            method: "POST",
            headers: _headers,
            contentType: "application/json",
            queryParameters: requestOptions?.queryParams,
            requestType: "json",
            body: request,
            timeoutMs: (requestOptions?.timeoutInSeconds ?? this._options?.timeoutInSeconds ?? 30) * 1000,
            maxRetries: requestOptions?.maxRetries ?? this._options?.maxRetries,
            withCredentials: true,
            abortSignal: requestOptions?.abortSignal,
            fetchFn: this._options?.fetch,
            logging: this._options.logging,
        });
        if (_response.ok) {
            return {
                data: _response.body,
                rawResponse: _response.rawResponse,
            };
        }
        if (_response.error.reason === "status-code") {
            switch (_response.error.statusCode) {
                case 422:
                    throw new AgentaApi.UnprocessableEntityError(_response.error.body, _response.rawResponse);
                default:
                    throw new errors.AgentaApiError({
                        statusCode: _response.error.statusCode,
                        body: _response.error.body,
                        rawResponse: _response.rawResponse,
                    });
            }
        }
        return handleNonStatusCodeError(_response.error, _response.rawResponse, "POST", "/channels/outbox/events/query");
    }
    /**
     * The space's inbox log plus what the outbox posted back, merged and
     * ordered by when each was written.
     *
     * @param {AgentaApi.ReadAgentaConversationRequest} request
     * @param {ChannelsClient.RequestOptions} requestOptions - Request-specific configuration.
     *
     * @throws {@link AgentaApi.UnprocessableEntityError}
     *
     * @example
     *     await client.channels.readAgentaConversation({
     *         id: "id"
     *     })
     */
    readAgentaConversation(request, requestOptions) {
        return core.HttpResponsePromise.fromPromise(this.__readAgentaConversation(request, requestOptions));
    }
    async __readAgentaConversation(request, requestOptions) {
        const { id } = request;
        const _authRequest = await this._options.authProvider.getAuthRequest();
        const _headers = mergeHeaders(_authRequest.headers, this._options?.headers, requestOptions?.headers);
        const _response = await core.fetcher({
            url: core.url.join((await core.Supplier.get(this._options.baseUrl)) ??
                (await core.Supplier.get(this._options.environment)) ??
                environments.AgentaApiEnvironment.Default, `channels/agenta/conversations/${core.url.encodePathParam(id)}`),
            method: "GET",
            headers: _headers,
            queryParameters: requestOptions?.queryParams,
            timeoutMs: (requestOptions?.timeoutInSeconds ?? this._options?.timeoutInSeconds ?? 30) * 1000,
            maxRetries: requestOptions?.maxRetries ?? this._options?.maxRetries,
            withCredentials: true,
            abortSignal: requestOptions?.abortSignal,
            fetchFn: this._options?.fetch,
            logging: this._options.logging,
        });
        if (_response.ok) {
            return { data: _response.body, rawResponse: _response.rawResponse };
        }
        if (_response.error.reason === "status-code") {
            switch (_response.error.statusCode) {
                case 422:
                    throw new AgentaApi.UnprocessableEntityError(_response.error.body, _response.rawResponse);
                default:
                    throw new errors.AgentaApiError({
                        statusCode: _response.error.statusCode,
                        body: _response.error.body,
                        rawResponse: _response.rawResponse,
                    });
            }
        }
        return handleNonStatusCodeError(_response.error, _response.rawResponse, "GET", "/channels/agenta/conversations/{id}");
    }
    /**
     * Whether this agent is connected to an active, verified bot, and
     * which channel tools its runs get under the bots' settings. The agent
     * runtime reads it to add the tools to every run.
     *
     * @param {AgentaApi.ChannelToolsAvailabilityRequest} request
     * @param {ChannelsClient.RequestOptions} requestOptions - Request-specific configuration.
     *
     * @throws {@link AgentaApi.UnprocessableEntityError}
     *
     * @example
     *     await client.channels.fetchChannelToolsAvailability({
     *         artifact_id: "artifact_id"
     *     })
     */
    fetchChannelToolsAvailability(request, requestOptions) {
        return core.HttpResponsePromise.fromPromise(this.__fetchChannelToolsAvailability(request, requestOptions));
    }
    async __fetchChannelToolsAvailability(request, requestOptions) {
        const _authRequest = await this._options.authProvider.getAuthRequest();
        const _headers = mergeHeaders(_authRequest.headers, this._options?.headers, requestOptions?.headers);
        const _response = await core.fetcher({
            url: core.url.join((await core.Supplier.get(this._options.baseUrl)) ??
                (await core.Supplier.get(this._options.environment)) ??
                environments.AgentaApiEnvironment.Default, "channels/tools/availability"),
            method: "POST",
            headers: _headers,
            contentType: "application/json",
            queryParameters: requestOptions?.queryParams,
            requestType: "json",
            body: request,
            timeoutMs: (requestOptions?.timeoutInSeconds ?? this._options?.timeoutInSeconds ?? 30) * 1000,
            maxRetries: requestOptions?.maxRetries ?? this._options?.maxRetries,
            withCredentials: true,
            abortSignal: requestOptions?.abortSignal,
            fetchFn: this._options?.fetch,
            logging: this._options.logging,
        });
        if (_response.ok) {
            return {
                data: _response.body,
                rawResponse: _response.rawResponse,
            };
        }
        if (_response.error.reason === "status-code") {
            switch (_response.error.statusCode) {
                case 422:
                    throw new AgentaApi.UnprocessableEntityError(_response.error.body, _response.rawResponse);
                default:
                    throw new errors.AgentaApiError({
                        statusCode: _response.error.statusCode,
                        body: _response.error.body,
                        rawResponse: _response.rawResponse,
                    });
            }
        }
        return handleNonStatusCodeError(_response.error, _response.rawResponse, "POST", "/channels/tools/availability");
    }
    /**
     * @param {AgentaApi.ChannelDestinationsQueryRequest} request
     * @param {ChannelsClient.RequestOptions} requestOptions - Request-specific configuration.
     *
     * @throws {@link AgentaApi.UnprocessableEntityError}
     *
     * @example
     *     await client.channels.queryChannelDestinations({
     *         artifact_id: "artifact_id"
     *     })
     */
    queryChannelDestinations(request, requestOptions) {
        return core.HttpResponsePromise.fromPromise(this.__queryChannelDestinations(request, requestOptions));
    }
    async __queryChannelDestinations(request, requestOptions) {
        const _authRequest = await this._options.authProvider.getAuthRequest();
        const _headers = mergeHeaders(_authRequest.headers, this._options?.headers, requestOptions?.headers);
        const _response = await core.fetcher({
            url: core.url.join((await core.Supplier.get(this._options.baseUrl)) ??
                (await core.Supplier.get(this._options.environment)) ??
                environments.AgentaApiEnvironment.Default, "channels/tools/destinations/query"),
            method: "POST",
            headers: _headers,
            contentType: "application/json",
            queryParameters: requestOptions?.queryParams,
            requestType: "json",
            body: request,
            timeoutMs: (requestOptions?.timeoutInSeconds ?? this._options?.timeoutInSeconds ?? 30) * 1000,
            maxRetries: requestOptions?.maxRetries ?? this._options?.maxRetries,
            withCredentials: true,
            abortSignal: requestOptions?.abortSignal,
            fetchFn: this._options?.fetch,
            logging: this._options.logging,
        });
        if (_response.ok) {
            return { data: _response.body, rawResponse: _response.rawResponse };
        }
        if (_response.error.reason === "status-code") {
            switch (_response.error.statusCode) {
                case 422:
                    throw new AgentaApi.UnprocessableEntityError(_response.error.body, _response.rawResponse);
                default:
                    throw new errors.AgentaApiError({
                        statusCode: _response.error.statusCode,
                        body: _response.error.body,
                        rawResponse: _response.rawResponse,
                    });
            }
        }
        return handleNonStatusCodeError(_response.error, _response.rawResponse, "POST", "/channels/tools/destinations/query");
    }
    /**
     * @param {AgentaApi.ChannelMessageSendRequest} request
     * @param {ChannelsClient.RequestOptions} requestOptions - Request-specific configuration.
     *
     * @throws {@link AgentaApi.UnprocessableEntityError}
     *
     * @example
     *     await client.channels.sendChannelMessage({
     *         artifact_id: "artifact_id",
     *         session_id: "session_id",
     *         tool_call_id: "tool_call_id",
     *         destination_id: "destination_id",
     *         text: "text"
     *     })
     */
    sendChannelMessage(request, requestOptions) {
        return core.HttpResponsePromise.fromPromise(this.__sendChannelMessage(request, requestOptions));
    }
    async __sendChannelMessage(request, requestOptions) {
        const _authRequest = await this._options.authProvider.getAuthRequest();
        const _headers = mergeHeaders(_authRequest.headers, this._options?.headers, requestOptions?.headers);
        const _response = await core.fetcher({
            url: core.url.join((await core.Supplier.get(this._options.baseUrl)) ??
                (await core.Supplier.get(this._options.environment)) ??
                environments.AgentaApiEnvironment.Default, "channels/tools/messages/send"),
            method: "POST",
            headers: _headers,
            contentType: "application/json",
            queryParameters: requestOptions?.queryParams,
            requestType: "json",
            body: request,
            timeoutMs: (requestOptions?.timeoutInSeconds ?? this._options?.timeoutInSeconds ?? 30) * 1000,
            maxRetries: requestOptions?.maxRetries ?? this._options?.maxRetries,
            withCredentials: true,
            abortSignal: requestOptions?.abortSignal,
            fetchFn: this._options?.fetch,
            logging: this._options.logging,
        });
        if (_response.ok) {
            return { data: _response.body, rawResponse: _response.rawResponse };
        }
        if (_response.error.reason === "status-code") {
            switch (_response.error.statusCode) {
                case 422:
                    throw new AgentaApi.UnprocessableEntityError(_response.error.body, _response.rawResponse);
                default:
                    throw new errors.AgentaApiError({
                        statusCode: _response.error.statusCode,
                        body: _response.error.body,
                        rawResponse: _response.rawResponse,
                    });
            }
        }
        return handleNonStatusCodeError(_response.error, _response.rawResponse, "POST", "/channels/tools/messages/send");
    }
    /**
     * @param {AgentaApi.ChannelMessagesReadRequest} request
     * @param {ChannelsClient.RequestOptions} requestOptions - Request-specific configuration.
     *
     * @throws {@link AgentaApi.UnprocessableEntityError}
     *
     * @example
     *     await client.channels.readChannelMessages({
     *         artifact_id: "artifact_id",
     *         destination_id: "destination_id"
     *     })
     */
    readChannelMessages(request, requestOptions) {
        return core.HttpResponsePromise.fromPromise(this.__readChannelMessages(request, requestOptions));
    }
    async __readChannelMessages(request, requestOptions) {
        const _authRequest = await this._options.authProvider.getAuthRequest();
        const _headers = mergeHeaders(_authRequest.headers, this._options?.headers, requestOptions?.headers);
        const _response = await core.fetcher({
            url: core.url.join((await core.Supplier.get(this._options.baseUrl)) ??
                (await core.Supplier.get(this._options.environment)) ??
                environments.AgentaApiEnvironment.Default, "channels/tools/messages/read"),
            method: "POST",
            headers: _headers,
            contentType: "application/json",
            queryParameters: requestOptions?.queryParams,
            requestType: "json",
            body: request,
            timeoutMs: (requestOptions?.timeoutInSeconds ?? this._options?.timeoutInSeconds ?? 30) * 1000,
            maxRetries: requestOptions?.maxRetries ?? this._options?.maxRetries,
            withCredentials: true,
            abortSignal: requestOptions?.abortSignal,
            fetchFn: this._options?.fetch,
            logging: this._options.logging,
        });
        if (_response.ok) {
            return { data: _response.body, rawResponse: _response.rawResponse };
        }
        if (_response.error.reason === "status-code") {
            switch (_response.error.statusCode) {
                case 422:
                    throw new AgentaApi.UnprocessableEntityError(_response.error.body, _response.rawResponse);
                default:
                    throw new errors.AgentaApiError({
                        statusCode: _response.error.statusCode,
                        body: _response.error.body,
                        rawResponse: _response.rawResponse,
                    });
            }
        }
        return handleNonStatusCodeError(_response.error, _response.rawResponse, "POST", "/channels/tools/messages/read");
    }
    /**
     * @param {AgentaApi.ChannelMessagesSearchRequest} request
     * @param {ChannelsClient.RequestOptions} requestOptions - Request-specific configuration.
     *
     * @throws {@link AgentaApi.UnprocessableEntityError}
     *
     * @example
     *     await client.channels.searchChannelMessages({
     *         artifact_id: "artifact_id",
     *         query: "query"
     *     })
     */
    searchChannelMessages(request, requestOptions) {
        return core.HttpResponsePromise.fromPromise(this.__searchChannelMessages(request, requestOptions));
    }
    async __searchChannelMessages(request, requestOptions) {
        const _authRequest = await this._options.authProvider.getAuthRequest();
        const _headers = mergeHeaders(_authRequest.headers, this._options?.headers, requestOptions?.headers);
        const _response = await core.fetcher({
            url: core.url.join((await core.Supplier.get(this._options.baseUrl)) ??
                (await core.Supplier.get(this._options.environment)) ??
                environments.AgentaApiEnvironment.Default, "channels/tools/messages/search"),
            method: "POST",
            headers: _headers,
            contentType: "application/json",
            queryParameters: requestOptions?.queryParams,
            requestType: "json",
            body: request,
            timeoutMs: (requestOptions?.timeoutInSeconds ?? this._options?.timeoutInSeconds ?? 30) * 1000,
            maxRetries: requestOptions?.maxRetries ?? this._options?.maxRetries,
            withCredentials: true,
            abortSignal: requestOptions?.abortSignal,
            fetchFn: this._options?.fetch,
            logging: this._options.logging,
        });
        if (_response.ok) {
            return { data: _response.body, rawResponse: _response.rawResponse };
        }
        if (_response.error.reason === "status-code") {
            switch (_response.error.statusCode) {
                case 422:
                    throw new AgentaApi.UnprocessableEntityError(_response.error.body, _response.rawResponse);
                default:
                    throw new errors.AgentaApiError({
                        statusCode: _response.error.statusCode,
                        body: _response.error.body,
                        rawResponse: _response.rawResponse,
                    });
            }
        }
        return handleNonStatusCodeError(_response.error, _response.rawResponse, "POST", "/channels/tools/messages/search");
    }
}
